import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import Hls from 'hls.js';
import { supabase } from './supabaseClient';
import logo from './logo.png';
import './App.css';

const ADMIN_EMAIL = 'vasiliyshto56@gmail.com';
const ADMIN_PASSWORD = '78bt68#$%@#$&^)(ml>_)*&^$%#%^^%$#@#';
const DEFAULT_AVATAR = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><rect width="120" height="120" fill="#15181f"/><circle cx="60" cy="46" r="22" fill="#5b6274"/><path d="M60 74c-25 0-40 15-40 36v10h80v-10c0-21-15-36-40-36z" fill="#5b6274"/></svg>');
const EMOJIS = ['🔥', '😂', '👍', '❤️', '🚀', '🎮', '🎉', '🏆', '👀', '✨', '🎶', '💪', '🙏'];
const NOTIF_SOUND_OPTIONS = [
    { id: 'chime', name: 'Перезвон' }, { id: 'pop', name: 'Поп' }, { id: 'arcade', name: 'Аркада' },
    { id: 'soft', name: 'Софт' }, { id: 'ping', name: 'Пинг' }, { id: 'drop', name: 'Капля' }, { id: 'fanfare', name: 'Фанфары' }
];
const TITLES = [
    { id: 'creator', name: 'Создатель', gradient: 'linear-gradient(135deg, #ff0000, #cc0000)', color: '#fff', icon: '👑' },
    { id: 'owner', name: 'Владелец', gradient: 'linear-gradient(135deg, #ff3333, #990000)', color: '#fff', icon: '💎' },
    { id: 'tech_admin', name: 'Тех.Админ', gradient: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', icon: '⚙️' },
    { id: 'admin', name: 'Администратор', gradient: 'linear-gradient(135deg, #f093fb, #f5576c)', color: '#fff', icon: '🛡️' },
    { id: 'moderator', name: 'Модератор', gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)', color: '#fff', icon: '⚡' },
    { id: 'sponsor_plus', name: 'Спонсор+', gradient: 'linear-gradient(135deg, #ffd700, #ffed4e)', color: '#000', icon: '⭐' },
    { id: 'sponsor', name: 'Спонсор', gradient: 'linear-gradient(135deg, #f6d365, #fda085)', color: '#000', icon: '💰' },
    { id: 'friend', name: 'Друг создателя', gradient: 'linear-gradient(135deg, #a8edea, #fed6e3)', color: '#000', icon: '🤝' },
    { id: 'old', name: 'Олд', gradient: 'linear-gradient(135deg, #a18cd1, #fbc2eb)', color: '#000', icon: '🏆' }
];
const QUALITY_OPTIONS = [
    { label: '4K', h: 2160, hd: true },
    { label: '1080p', h: 1080, hd: true },
    { label: '720p', h: 720, hd: false },
    { label: '480p', h: 480, hd: false },
    { label: '360p', h: 360, hd: false }
];

let sharedCtx = null;
const getCtx = () => {
    if (!sharedCtx) { const C = window.AudioContext || window.webkitAudioContext; sharedCtx = new C(); }
    if (sharedCtx.state === 'suspended') sharedCtx.resume().catch(() => {});
    return sharedCtx;
};
const playNotifSound = (volumePct, type) => {
    type = type || 'chime';
    try {
        const ctx = getCtx();
        const vol = Math.max(0, Math.min(100, volumePct)) / 100 * 0.3;
        const now = ctx.currentTime;
        const tone = (f, t, d, o, g) => {
            const os = ctx.createOscillator(); const gn = ctx.createGain();
            os.type = o; os.frequency.value = f;
            gn.gain.setValueAtTime(0.0001, now + t);
            gn.gain.linearRampToValueAtTime(g, now + t + 0.02);
            gn.gain.exponentialRampToValueAtTime(0.0001, now + t + d);
            os.connect(gn); gn.connect(ctx.destination);
            os.start(now + t); os.stop(now + t + d + 0.05);
        };
        if (type === 'pop') {
            const o = ctx.createOscillator(); const g = ctx.createGain();
            o.type = 'sine';
            o.frequency.setValueAtTime(300, now);
            o.frequency.exponentialRampToValueAtTime(900, now + 0.12);
            g.gain.setValueAtTime(vol, now);
            g.gain.exponentialRampToValueAtTime(0.0001, now + 0.18);
            o.connect(g); g.connect(ctx.destination);
            o.start(now); o.stop(now + 0.2);
        } else if (type === 'arcade') {
            tone(523.25, 0, 0.12, 'square', vol * 0.6);
            tone(659.25, 0.1, 0.12, 'square', vol * 0.6);
            tone(783.99, 0.2, 0.2, 'square', vol * 0.6);
        } else if (type === 'soft') {
            tone(660, 0, 0.3, 'sine', vol * 0.8);
            tone(880, 0.15, 0.35, 'sine', vol * 0.5);
        } else if (type === 'ping') {
            tone(1318.5, 0, 0.25, 'sine', vol);
        } else if (type === 'drop') {
            const o = ctx.createOscillator(); const g = ctx.createGain();
            o.type = 'sine';
            o.frequency.setValueAtTime(950, now);
            o.frequency.exponentialRampToValueAtTime(280, now + 0.25);
            g.gain.setValueAtTime(vol, now);
            g.gain.exponentialRampToValueAtTime(0.0001, now + 0.3);
            o.connect(g); g.connect(ctx.destination);
            o.start(now); o.stop(now + 0.32);
        } else if (type === 'fanfare') {
            tone(523.25, 0, 0.15, 'square', vol * 0.5);
            tone(659.25, 0.12, 0.15, 'square', vol * 0.5);
            tone(783.99, 0.24, 0.15, 'square', vol * 0.5);
            tone(1046.5, 0.36, 0.3, 'square', vol * 0.6);
        } else {
            tone(880, 0, 0.2, 'sine', vol);
            tone(1174.66, 0.12, 0.25, 'sine', vol * 0.7);
        }
    } catch (e) {}
};
const showBrowserNotif = (title, body, prefs) => {
    if (typeof Notification === 'undefined') return;
    if (Notification.permission !== 'granted') return;
    if (!prefs || !prefs.notifications) return;
    try {
        const n = new Notification(title, { body, icon: '/logo.png', silent: true });
        setTimeout(() => { try { n.close(); } catch (e) {} }, 8000);
    } catch (e) {}
    if (prefs.notifSound !== false) playNotifSound(prefs.notifVolume || 70, prefs.notifSoundType || 'chime');
};
const safeParse = (s) => { try { return JSON.parse(s); } catch (e) { return null; } };
const genUuid = () => 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
});
const mapChannel = (r) => ({
    id: r.id, name: r.name, category: r.category, desc: r.description || '',
    streamUrl: r.stream_url || '', image: r.image_url || null, live: !!r.is_live,
    isOfficial: !!r.is_official, isAd: !!r.is_ad, isPartner: !!r.is_partner,
    maintenance: !!r.maintenance, maintenanceUntil: r.maintenance_until || '',
    maintenanceLink: r.maintenance_link || ''
});
const schedSortKey = (t) => {
    const m = /^(\d{1,2}):(\d{2})/.exec(t || '');
    if (!m) return 9999;
    let h = parseInt(m[1], 10);
    const mm = parseInt(m[2], 10);
    if (h < 6) h += 24;
    return h * 60 + mm;
};
const buildSchedules = (rows) => {
    const m = {};
    rows.forEach(r => {
        if (!m[r.channel_id]) m[r.channel_id] = {};
        if (!m[r.channel_id][r.day_name]) m[r.channel_id][r.day_name] = [];
        m[r.channel_id][r.day_name].push({ id: r.id, time: r.time, title: r.title });
    });
    Object.keys(m).forEach(cid => {
        Object.keys(m[cid]).forEach(d => {
            m[cid][d].sort((a, b) => schedSortKey(a.time) - schedSortKey(b.time));
        });
    });
    return m;
};
const mapMessage = (r) => ({
    id: r.id, user: r.username || 'Зритель', userId: r.user_id, text: r.text,
    time: r.created_at ? new Date(r.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '',
    isDeleted: !!r.is_deleted, deletedBy: r.deleted_by, isEdited: !!r.is_edited,
    replyTo: r.reply_to ? safeParse(r.reply_to) : null, isSystem: false
});

const TitleBadge = ({ titleId, size = 'sm' }) => {
    const title = TITLES.find(t => t.id === titleId);
    if (!title) return null;
    const sizes = { sm: { fontSize: '10px', padding: '2px 8px' }, md: { fontSize: '12px', padding: '4px 12px' }, lg: { fontSize: '14px', padding: '6px 14px' } };
    return (
        <span style={{ background: title.gradient, color: title.color, ...sizes[size], borderRadius: '12px', fontWeight: '700', display: 'inline-flex', alignItems: 'center', gap: '4px', marginLeft: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
      <span>{title.icon}</span>
      <span>{title.name}</span>
    </span>
    );
};

const useOnlineHeartbeat = (activeChannelId) => {
    const [byChannel, setByChannel] = useState({});
    const [total, setTotal] = useState(0);
    const activeRef = useRef(activeChannelId);
    useEffect(() => { activeRef.current = activeChannelId; }, [activeChannelId]);
    useEffect(() => {
        let deviceId = localStorage.getItem('livenet_device_id');
        if (!deviceId) { deviceId = genUuid(); localStorage.setItem('livenet_device_id', deviceId); }
        const recount = async () => {
            const cutoff = new Date(Date.now() - 8000).toISOString();
            const { data } = await supabase.from('online_heartbeats').select('device_id, channel_id').gt('last_seen', cutoff);
            if (data) {
                const bc = {};
                data.forEach(r => { if (r.channel_id) bc[r.channel_id] = (bc[r.channel_id] || 0) + 1; });
                setByChannel(bc);
                setTotal(data.length);
            }
        };
        const beat = async () => {
            await supabase.from('online_heartbeats').upsert({ device_id: deviceId, channel_id: activeRef.current, last_seen: new Date().toISOString() }, { onConflict: 'device_id' });
            supabase.from('online_heartbeats').delete().lt('last_seen', new Date(Date.now() - 30000).toISOString()).then(() => {});
            recount();
        };
        beat();
        const iv = setInterval(beat, 2000);
        const ch = supabase.channel('hb_watch').on('postgres_changes', { event: '*', schema: 'public', table: 'online_heartbeats' }, () => { recount(); }).subscribe();
        const onHide = () => { if (document.visibilityState === 'hidden') supabase.from('online_heartbeats').delete().eq('device_id', deviceId).then(() => {}); };
        document.addEventListener('visibilitychange', onHide);
        return () => {
            clearInterval(iv);
            supabase.removeChannel(ch);
            document.removeEventListener('visibilitychange', onHide);
            supabase.from('online_heartbeats').delete().eq('device_id', deviceId).then(() => {});
        };
    }, []);
    return { byChannel, total };
};

const ImageCropper = ({ shape, title, onSave, onClose, allowAnimated }) => {
    const isCircle = shape === 'circle';
    const viewportW = isCircle ? 260 : 560;
    const viewportH = isCircle ? 260 : 100;
    const [imgSrc, setImgSrc] = useState(null);
    const [natural, setNatural] = useState({ w: 0, h: 0 });
    const [zoom, setZoom] = useState(1);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [err, setErr] = useState('');
    const imgRef = useRef(null);
    const dragRef = useRef(null);
    const cover = natural.w ? Math.max(viewportW / natural.w, viewportH / natural.h) : 1;
    const scale = cover * zoom;
    const w = natural.w * scale;
    const h = natural.h * scale;
    const clamp = (ox, oy, ww, hh) => ({ x: Math.min(0, Math.max(viewportW - ww, ox)), y: Math.min(0, Math.max(viewportH - hh, oy)) });
    useEffect(() => { if (!natural.w) return; setOffset(prev => clamp(prev.x, prev.y, w, h)); }, [zoom, natural, w, h]);
    const handleFile = (e) => {
        const f = e.target.files[0];
        if (!f) return;
        setErr('');
        if (f.type === 'image/gif') {
            if (!allowAnimated) { setErr('Анимированные изображения доступны только администрации'); return; }
            const r = new FileReader();
            r.onload = (ev) => onSave(ev.target.result);
            r.readAsDataURL(f);
            return;
        }
        const r = new FileReader();
        r.onload = (ev) => {
            const src = ev.target.result;
            const img = new Image();
            img.onload = () => {
                setNatural({ w: img.width, h: img.height });
                setZoom(1);
                const s = Math.max(viewportW / img.width, viewportH / img.height);
                setOffset({ x: (viewportW - img.width * s) / 2, y: (viewportH - img.height * s) / 2 });
                setImgSrc(src);
            };
            img.src = src;
        };
        r.readAsDataURL(f);
    };
    const onDown = (e) => {
        if (!imgSrc) return;
        e.preventDefault();
        dragRef.current = { sx: e.clientX, sy: e.clientY, ox: offset.x, oy: offset.y, w, h };
        const mv = (ev) => {
            const d = dragRef.current;
            if (!d) return;
            setOffset({
                x: Math.min(0, Math.max(viewportW - d.w, d.ox + ev.clientX - d.sx)),
                y: Math.min(0, Math.max(viewportH - d.h, d.oy + ev.clientY - d.sy))
            });
        };
        const up = () => { dragRef.current = null; window.removeEventListener('mousemove', mv); window.removeEventListener('mouseup', up); };
        window.addEventListener('mousemove', mv);
        window.addEventListener('mouseup', up);
    };
    const save = () => {
        if (!imgRef.current) return;
        const oW = isCircle ? 256 : 1680;
        const oH = isCircle ? 256 : 300;
        const c = document.createElement('canvas');
        c.width = oW; c.height = oH;
        const x = c.getContext('2d');
        const rx = oW / viewportW; const ry = oH / viewportH;
        x.drawImage(imgRef.current, offset.x * rx, offset.y * ry, w * rx, h * ry);
        onSave(c.toDataURL('image/jpeg', 0.85));
    };
    return (
        <div className="auth-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="cropper-card">
                <h3>{title}</h3>
                <p className="cropper-hint">Выберите фото, подвиньте и настройте масштаб.{!isCircle ? ' Область обрезки совпадает с итоговой шапкой.' : ''}</p>
                {err && <div className="auth-error">{err}</div>}
                <div className={'cropper-viewport ' + (isCircle ? 'circle' : '')} style={{ width: viewportW, height: viewportH, maxWidth: '100%' }} onMouseDown={onDown}>
                    {imgSrc ? <img ref={imgRef} src={imgSrc} alt="crop" draggable={false} style={{ width: w, height: h, transform: 'translate(' + offset.x + 'px,' + offset.y + 'px)' }} /> : <div className="cropper-placeholder">Изображение не выбрано</div>}
                </div>
                {imgSrc && (
                    <div className="cropper-zoom">
                        <span>−</span>
                        <input type="range" min="1" max="3" step="0.05" value={zoom} onChange={(e) => setZoom(Number(e.target.value))} />
                        <span>+</span>
                        <em>Масштаб</em>
                    </div>
                )}
                <label className="btn-ghost cropper-upload">📁 Выбрать изображение
                    <input type="file" accept="image/*" onChange={handleFile} style={{ display: 'none' }} />
                </label>
                <div className="cropper-actions">
                    <button className="btn-primary" onClick={save} disabled={!imgSrc}>Сохранить</button>
                    <button className="btn-ghost" onClick={onClose}>Отмена</button>
                </div>
            </div>
        </div>
    );
};

const Splash = () => (
    <div className="splash-screen">
        <div className="splash-logo-row">
            <span className="splash-title">LiveNe<span className="splash-t">t</span></span>
            <img src={logo} alt="LiveNet" className="splash-logo" />
        </div>
        <div className="splash-tag">Смотри что хочешь, когда хочешь 💜</div>
    </div>
);

const Header = (p) => {
    const username = p.profileExtras.username || 'livenet_user';
    const avatarSrc = p.profileExtras.avatar || (p.userProfile ? p.userProfile.avatar_url : '') || DEFAULT_AVATAR;
    return (
        <header className="header-root">
            <div className="header-inner">
                <div className="header-logo-wrap" onClick={() => p.setCurrentRoute('main')}>
                    <div className="logo-badge"><img src={logo} alt="LiveNet" /></div>
                    <span className="header-logo-text">
            <span className="logo-live">Live</span>
            <span className="logo-net">Net</span>
          </span>
                </div>
                <nav className="header-nav">
                    <button className={'nav-link ' + (p.currentRoute === 'main' ? 'active' : '')} onClick={() => p.setCurrentRoute('main')}>Главная</button>
                    <button className={'nav-link ' + (p.currentRoute === 'channels' ? 'active' : '')} onClick={() => p.setCurrentRoute('channels')}>Каналы</button>
                    <button className={'nav-link ' + (p.currentRoute === 'about' ? 'active' : '')} onClick={() => p.setCurrentRoute('about')}>О нас</button>
                </nav>
                <div className="header-actions">
                    {p.isAdmin && (
                        <button className="icon-btn" onClick={() => p.setCurrentRoute('admin')} title="Админ-панель">
                            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                        </button>
                    )}
                    <div className="dropdown-container" ref={p.notifRef}>
                        <button className="icon-btn" onClick={() => { p.setNotifOpen(!p.notifOpen); p.setProfileOpen(false); }} title="Уведомления">
                            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                            {p.unreadCount > 0 && <span className="notification-badge">{p.unreadCount}</span>}
                        </button>
                        {p.notifOpen && (
                            <div className="popup-dropdown notif-popup">
                                <div className="popup-header">
                                    <h3>Уведомления</h3>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <button className="text-btn" onClick={p.markAllRead}>Прочитать все</button>
                                        <button className="text-btn danger" onClick={p.clearAllNotifs}>Удалить все</button>
                                    </div>
                                </div>
                                <div className="popup-body">
                                    {p.notifications.length === 0 && <p style={{ padding: '20px', color: 'var(--text-muted)', fontSize: '13px', textAlign: 'center' }}>Уведомлений нет</p>}
                                    {p.notifications.map((n) => (
                                        <div key={n.id} className={'notif-item clickable ' + (!n.is_read ? 'unread' : '')} onClick={() => p.onNotifClick(n)}>
                                            <div className="notif-dot"></div>
                                            <div className="notif-content">
                                                <p>{n.text}</p>
                                                <span className="notif-time">{n.time}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    {p.session ? (
                        <div className="dropdown-container" ref={p.profileRef}>
                            <div className="avatar-trigger" onClick={() => { p.setProfileOpen(!p.profileOpen); p.setNotifOpen(false); }}>
                                <img src={avatarSrc} alt="Avatar" className="header-avatar" />
                            </div>
                            {p.profileOpen && (
                                <div className="popup-dropdown profile-popup">
                                    <div className="profile-popup-header">
                                        <img src={avatarSrc} alt="Avatar" className="popup-avatar-lg" />
                                        <div>
                                            <h4 className="popup-username">{p.displayName}</h4>
                                            <span className="popup-tag">@{username}</span>
                                        </div>
                                    </div>
                                    <div className="popup-divider"></div>
                                    <div className="popup-menu-list">
                                        <button onClick={() => { p.onOpenProfile(); p.setProfileOpen(false); }}>Мой профиль</button>
                                        <button onClick={() => { p.setCurrentRoute('subscriptions'); p.setProfileOpen(false); }}>Подписки</button>
                                        <button onClick={() => { p.setCurrentRoute('settings'); p.setProfileOpen(false); }}>Настройки</button>
                                    </div>
                                    <div className="popup-divider"></div>
                                    <button className="popup-logout" onClick={() => supabase.auth.signOut()}>Выйти из аккаунта</button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button className="btn-ghost" onClick={() => p.onOpenAuth('login')}>Войти</button>
                            <button className="btn-primary" onClick={() => p.onOpenAuth('register')}>Регистрация</button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

const AuthModal = ({ authMode, onClose, onSwitchMode }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [nick, setNick] = useState('');
    const [otp, setOtp] = useState('');
    const [step, setStep] = useState('form');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [info, setInfo] = useState('');
    const submit = async (e) => {
        e.preventDefault(); setError(''); setInfo('');
        if (!email.trim() || !password.trim()) { setError('Заполните email и пароль'); return; }
        if (password.length < 6) { setError('Пароль минимум 6 символов'); return; }
        setLoading(true);
        try {
            if (authMode === 'login') {
                const { error: er } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
                if (er) setError(er.message); else onClose();
            } else {
                const { error: er } = await supabase.auth.signUp({ email: email.trim(), password, options: { data: { display_name: nick.trim() || 'LiveNet User' } } });
                if (er) setError(er.message); else { setStep('otp'); setInfo('Код подтверждения отправлен на ' + email.trim()); }
            }
        } catch (er) { setError('Ошибка соединения'); }
        setLoading(false);
    };
    const verifyOtp = async (e) => {
        e.preventDefault(); setError('');
        if (!otp.trim()) { setError('Введите код'); return; }
        setLoading(true);
        try {
            const { error: ver } = await supabase.auth.verifyOtp({ email: email.trim(), token: otp.trim(), type: 'email' });
            if (ver) setError(ver.message); else onClose();
        } catch (er) { setError('Ошибка соединения'); }
        setLoading(false);
    };
    return (
        <div className="auth-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="auth-card">
                <button className="auth-close" onClick={onClose}>✕</button>
                <div className="auth-logo-row">
                    <img src={logo} alt="LiveNet" />
                    <span>Live<span className="gradient-text">Net</span></span>
                </div>
                {step === 'otp' ? (
                    <form onSubmit={verifyOtp}>
                        <div className="auth-info">
                            <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>📧 Проверьте почту</div>
                            <div style={{ fontSize: '13px' }}>Мы отправили код подтверждения на <strong>{email.trim()}</strong></div>
                        </div>
                        {error && <div className="auth-error">{error}</div>}
                        <div className="auth-field">
                            <label className="auth-label">Код из письма</label>
                            <input type="text" className="admin-input" value={otp} onChange={(e) => setOtp(e.target.value)} placeholder="Введите 6-значный код" autoFocus />
                        </div>
                        <button type="submit" className="btn-primary" style={{ width: '100%', padding: '14px' }} disabled={loading}>{loading ? 'Проверка...' : 'Подтвердить'}</button>
                    </form>
                ) : (
                    <React.Fragment>
                        <div className="auth-tabs">
                            <button type="button" className={'auth-tab ' + (authMode === 'login' ? 'active' : '')} onClick={() => { setError(''); setInfo(''); onSwitchMode('login'); }}>Вход</button>
                            <button type="button" className={'auth-tab ' + (authMode === 'register' ? 'active' : '')} onClick={() => { setError(''); setInfo(''); onSwitchMode('register'); }}>Регистрация</button>
                        </div>
                        {error && <div className="auth-error">{error}</div>}
                        {info && <div className="auth-info">{info}</div>}
                        <form onSubmit={submit}>
                            {authMode === 'register' && (
                                <div className="auth-field">
                                    <label className="auth-label">Имя пользователя</label>
                                    <input type="text" className="admin-input" value={nick} onChange={(e) => setNick(e.target.value)} placeholder="Ваш ник в эфире" />
                                </div>
                            )}
                            <div className="auth-field">
                                <label className="auth-label">Email</label>
                                <input type="email" className="admin-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@livenet.com" autoFocus />
                            </div>
                            <div className="auth-field">
                                <label className="auth-label">Пароль</label>
                                <input type="password" className="admin-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Минимум 6 символов" />
                            </div>
                            <button type="submit" className="btn-primary" style={{ width: '100%', padding: '14px' }} disabled={loading}>{loading ? 'Подождите...' : (authMode === 'login' ? 'Войти' : 'Создать аккаунт')}</button>
                        </form>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

const MainPage = ({ setCurrentRoute }) => {
    const def = { transform: 'perspective(1000px) rotateX(8deg) rotateY(-12deg)', transition: 'transform 0.6s cubic-bezier(0.2,0.8,0.2,1)' };
    const [tilt, setTilt] = useState(def);
    const move = (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        setTilt({ transform: 'perspective(1000px) rotateX(' + (-y * 20) + 'deg) rotateY(' + (x * 20) + 'deg)', transition: 'transform 0.1s ease-out' });
    };
    return (
        <div className="main-hero-page">
            <div className="section-container hero-container">
                <div className="hero-content">
                    <div className="hero-badge">Официальный медиапортал LiveNet</div>
                    <h1 className="hero-title">Телевидение<br /><span className="gradient-text">нового</span><br /><span className="gradient-purple">поколения</span></h1>
                    <p className="hero-desc">LiveNet — ваш главный премиальный источник контента, киберспорта, музыки и прямых эфиров без задержек.</p>
                    <div className="hero-buttons">
                        <button className="btn-primary btn-glow" onClick={() => setCurrentRoute('channels')}>Смотреть каналы</button>
                        <button className="btn-ghost" onClick={() => setCurrentRoute('about')}>О платформе</button>
                    </div>
                    <div className="hero-stats">
                        <div className="stat-card"><h3>24/7</h3><span>Вещание</span></div>
                        <div className="stat-card"><h3>1080p</h3><span>Ultra HD</span></div>
                        <div className="stat-card"><h3>0 сек</h3><span>Задержка</span></div>
                    </div>
                </div>
                <div className="hero-visual-wrapper" onMouseMove={move} onMouseLeave={() => setTilt(def)} style={tilt}>
                    <div className="floating-card glow-effect">
                        <img src={logo} alt="LiveNet" className="hero-logo-center" />
                        <div className="pulse-live-ring"></div>
                    </div>
                    <div className="floating-badge badge-1">1080p Ultra HD</div>
                    <div className="floating-badge badge-2"><div className="live-dot-indicator"></div>LIVE STREAM</div>
                </div>
            </div>
        </div>
    );
};

const ChannelsPage = ({ adminCategories, adminChannels, setSelectedChannel, setCurrentRoute, loading, onlineByChannel }) => {
    const [q, setQ] = useState('');
    const [cat, setCat] = useState('Все');
    const [start, setStart] = useState(0);
    const catNames = adminCategories.map(c => c.name);
    const list = ['Все', ...catNames];
    const vis = list.slice(start, start + 4);
    const rank = (c) => c.isOfficial ? 0 : c.isPartner ? 1 : c.isAd ? 2 : 3;
    const sorted = useMemo(() => [...adminChannels].sort((a, b) => rank(a) - rank(b)), [adminChannels]);
    const filtered = useMemo(() => sorted.filter(c => {
        const matchesSearch = c.name.toLowerCase().includes(q.toLowerCase()) || c.desc.toLowerCase().includes(q.toLowerCase());
        if (cat === 'Все') return matchesSearch;
        const cats = (c.category || '').split(',').map(s => s.trim());
        return matchesSearch && cats.includes(cat);
    }), [sorted, q, cat]);
    return (
        <div className="channels-page section-container" style={{ padding: '50px 20px', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ marginBottom: '30px' }}>
                <h1 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '8px' }}>Телеканалы <span className="gradient-text">LiveNet</span></h1>
                <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem' }}>Выберите канал, общайтесь в чате и наслаждайтесь эфиром</p>
            </div>
            <div className="channels-controls" style={{ display: 'flex', gap: '20px', marginBottom: '35px', flexWrap: 'nowrap', alignItems: 'center', width: '100%', overflowX: 'auto' }}>
                <input type="text" placeholder="Поиск телеканалов..." value={q} onChange={(e) => setQ(e.target.value)} className="admin-input" style={{ minWidth: '280px', maxWidth: '320px', margin: 0, flexShrink: 0 }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                    {start > 0 && (
                        <button className="icon-btn" onClick={() => setStart(start - 1)} style={{ width: '38px', height: '38px', borderRadius: '10px' }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6" /></svg>
                        </button>
                    )}
                    {vis.map((c) => (
                        <button key={c} className={'nav-link ' + (cat === c ? 'active' : '')} onClick={() => setCat(c)} style={{ background: cat === c ? 'rgba(0,245,160,0.12)' : 'var(--bg-secondary)', border: '1px solid var(--border-color)', whiteSpace: 'nowrap', borderRadius: '10px', padding: '9px 16px', flexShrink: 0 }}>{c}</button>
                    ))}
                    {start + 4 < list.length && (
                        <button className="icon-btn" onClick={() => setStart(start + 1)} style={{ width: '38px', height: '38px', borderRadius: '10px' }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg>
                        </button>
                    )}
                </div>
            </div>
            {loading ? <p style={{ color: 'var(--text-muted)' }}>Загрузка каналов...</p> : (
                <div className="channels-grid">
                    {filtered.length > 0 ? filtered.map((ch) => {
                        const online = onlineByChannel[ch.id] || 0;
                        return (
                            <div key={ch.id} className="channel-card" style={{ position: 'relative' }}>
                                <div style={{ position: 'absolute', top: '14px', left: '14px', display: 'flex', gap: '6px', zIndex: 2, flexWrap: 'wrap' }}>
                                    {ch.isOfficial && <span style={{ background: '#ef4444', color: '#fff', fontSize: '11px', fontWeight: '700', padding: '3px 8px', borderRadius: '6px' }}>Официальный</span>}
                                    {ch.isPartner && <span style={{ background: 'rgba(0,245,160,0.2)', color: 'var(--accent-primary)', fontSize: '11px', fontWeight: '700', padding: '3px 8px', borderRadius: '6px' }}>Партнер</span>}
                                    {ch.isAd && <span style={{ background: '#f59e0b', color: '#000', fontSize: '11px', fontWeight: '700', padding: '3px 8px', borderRadius: '6px' }}>Реклама</span>}
                                </div>
                                <div className="channel-card-top" style={{ marginTop: (ch.isOfficial || ch.isAd || ch.isPartner) ? '20px' : '0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className="channel-avatar-badge"><img src={ch.image || logo} alt={ch.name} /></div>
                                </div>
                                <div className="channel-card-body">
                                    <h3>{ch.name}</h3>
                                    <span className="channel-cat-tag">{ch.category}</span>
                                    <p>{ch.desc}</p>
                                </div>
                                <div className="channel-card-footer">
                                    <div style={{ marginBottom: '10px' }}><span className="stat-chip">👁 <b>{online}</b> онлайн</span></div>
                                    <button className="btn-primary" style={{ width: '100%' }} onClick={() => { setSelectedChannel(ch); setCurrentRoute('player'); }}>Смотреть эфир</button>
                                </div>
                            </div>
                        );
                    }) : <p style={{ color: 'var(--text-muted)' }}>Каналы не найдены.</p>}
                </div>
            )}
        </div>
    );
};

const AboutPage = () => (
    <div className="section-container" style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ maxWidth: '850px', marginBottom: '50px' }}>
            <div className="hero-badge" style={{ display: 'inline-block', marginBottom: '16px' }}>О платформе</div>
            <h1 className="gradient-text" style={{ fontSize: '3rem', fontWeight: '900', marginBottom: '20px', lineHeight: '1.1' }}>Медиапространство LiveNet</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '1.2rem', lineHeight: '1.7', marginBottom: '16px' }}>LiveNet — передовая стриминговая экосистема нового поколения. Лучшие телеканалы, интерактивные трансляции и яркое комьюнити 24/7.</p>
            <div style={{ fontSize: '15px', color: 'var(--accent-primary)', fontWeight: '600' }}>Дата создания телеканала: 06.08.2025</div>
            <div className="birthday-chip">🎉 1 год в эфире — с днём рождения, LiveNet!</div>
        </div>
        <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '24px' }}>Наши официальные ресурсы и соцсети</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
            <a href="https://www.youtube.com/@livenet_fm" target="_blank" rel="noopener noreferrer" className="social-card" style={{ textDecoration: 'none', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)', padding: '24px', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ width: '50px', height: '50px', borderRadius: '14px', background: 'rgba(255,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="#ff0000"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
                </div>
                <div>
                    <h4 style={{ fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>YouTube</h4>
                    <span style={{ fontSize: '14px', color: 'var(--accent-primary)', fontWeight: '600' }}>@livenet_fm</span>
                </div>
            </a>
            <a href="https://www.youtube.com/@livenet_off1cial" target="_blank" rel="noopener noreferrer" className="social-card" style={{ textDecoration: 'none', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)', padding: '24px', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ width: '50px', height: '50px', borderRadius: '14px', background: 'rgba(255,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="#ff0000"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
                </div>
                <div>
                    <h4 style={{ fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>YouTube</h4>
                    <span style={{ fontSize: '14px', color: 'var(--accent-primary)', fontWeight: '600' }}>@livenet_off1cial</span>
                </div>
            </a>
            <a href="https://t.me/livenet_official" target="_blank" rel="noopener noreferrer" className="social-card" style={{ textDecoration: 'none', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)', padding: '24px', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ width: '50px', height: '50px', borderRadius: '14px', background: 'rgba(0,136,204,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="#0088cc"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.14-.26.26-.534.26l.213-3.053 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.824.938z" /></svg>
                </div>
                <div>
                    <h4 style={{ fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>Telegram</h4>
                    <span style={{ fontSize: '14px', color: 'var(--accent-primary)', fontWeight: '600' }}>@livenet_official</span>
                </div>
            </a>
        </div>
    </div>
);

const ChannelMaintenanceScreen = ({ channel, onBack }) => {
    const [left, setLeft] = useState('');
    useEffect(() => {
        if (!channel.maintenanceUntil) { setLeft(''); return; }
        const tick = () => {
            const diff = new Date(channel.maintenanceUntil).getTime() - Date.now();
            if (diff <= 0) { setLeft(''); return; }
            const d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
            setLeft((d > 0 ? d + 'д ' : '') + (h > 0 ? h + 'ч ' : '') + m + 'м ' + s + 'с');
        };
        tick();
        const iv = setInterval(tick, 1000);
        return () => clearInterval(iv);
    }, [channel.maintenanceUntil]);
    return (
        <div className="ch-maint">
            <div className="ch-maint-gear">⚙️</div>
            <h2>Технические работы</h2>
            <p>Канал <b>{channel.name}</b> временно на технических работах.<br />Мы уже всё чиним — скоро вернёмся!</p>
            {left && <div className="ch-maint-timer">⏳ {left}</div>}
            {channel.maintenanceLink && (
                <a className="ch-maint-link" href={channel.maintenanceLink} target="_blank" rel="noopener noreferrer">
                    <span className="ch-maint-link-icon">📰</span> Новости и обновления — тут
                </a>
            )}
            <button className="btn-ghost" onClick={onBack}>← Назад к каналам</button>
        </div>
    );
};

const PlayerPage = ({ selectedChannel, setCurrentRoute, schedules, isAdmin, session, displayName, onRequireAuth, subscriptions, toggleSubscription, prefs, highlightUser, openUserProfile, onlineByChannel, toast }) => {
    const autoplay = prefs.autoplay !== false;
    const showChat = prefs.chatEnabled !== false;
    const uid = session ? session.user.id : null;
    const streamUrl = selectedChannel && selectedChannel.streamUrl ? selectedChannel.streamUrl.trim() : '';
    const isHls = /.m3u8($|\?)/i.test(streamUrl);
    const hasStream = !!streamUrl;
    const isOffline = !selectedChannel || !hasStream;
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [volume, setVolume] = useState(100);
    const [controlsVisible, setControlsVisible] = useState(true);
    const [quality, setQuality] = useState('Авто');
    const [qualityOpen, setQualityOpen] = useState(false);
    const [levels, setLevels] = useState([]);
    const ctrlTimer = useRef(null);
    const playingRef = useRef(isPlaying);
    const hlsRef = useRef(null);
    const glowRef = useRef(null);
    useEffect(() => { playingRef.current = isPlaying; }, [isPlaying]);
    const reveal = useCallback(() => {
        setControlsVisible(true);
        clearTimeout(ctrlTimer.current);
        ctrlTimer.current = setTimeout(() => { if (playingRef.current) setControlsVisible(false); }, 5000);
    }, []);
    useEffect(() => {
        if (!isPlaying) { setControlsVisible(true); clearTimeout(ctrlTimer.current); } else { reveal(); }
    }, [isPlaying, reveal]);
    useEffect(() => () => clearTimeout(ctrlTimer.current), []);
    useEffect(() => { setQuality('Авто'); setLevels([]); }, [streamUrl]);
    const [likes, setLikes] = useState(0);
    const [dislikes, setDislikes] = useState(0);
    const [userReaction, setUserReaction] = useState(null);
    const [subCount, setSubCount] = useState(0);
    const onlineNow = onlineByChannel[selectedChannel ? selectedChannel.id : null] || 0;
    const loadReactions = useCallback(async () => {
        if (!selectedChannel) return;
        const [lc, dc] = await Promise.all([
            supabase.from('channel_reactions').select('*', { count: 'exact', head: true }).eq('channel_id', selectedChannel.id).eq('reaction', 'like'),
            supabase.from('channel_reactions').select('*', { count: 'exact', head: true }).eq('channel_id', selectedChannel.id).eq('reaction', 'dislike')
        ]);
        setLikes(lc.count || 0); setDislikes(dc.count || 0);
        if (uid) {
            const { data } = await supabase.from('channel_reactions').select('reaction').eq('channel_id', selectedChannel.id).eq('user_id', uid).maybeSingle();
            setUserReaction(data ? data.reaction : null);
        } else setUserReaction(null);
    }, [selectedChannel, uid]);
    useEffect(() => { loadReactions(); }, [loadReactions]);
    const loadSubCount = useCallback(() => {
        if (!selectedChannel) return;
        supabase.from('subscriptions').select('*', { count: 'exact', head: true }).eq('channel_id', selectedChannel.id).then(r => setSubCount(r.count || 0));
    }, [selectedChannel]);
    useEffect(() => { loadSubCount(); }, [loadSubCount]);
    useEffect(() => {
        if (!selectedChannel) return;
        const ch = supabase.channel('react_' + selectedChannel.id).on('postgres_changes', { event: '*', schema: 'public', table: 'channel_reactions', filter: 'channel_id=eq.' + selectedChannel.id }, () => { loadReactions(); }).subscribe();
        const ch2 = supabase.channel('subs_' + selectedChannel.id).on('postgres_changes', { event: '*', schema: 'public', table: 'subscriptions', filter: 'channel_id=eq.' + selectedChannel.id }, () => { loadSubCount(); }).subscribe();
        return () => { supabase.removeChannel(ch); supabase.removeChannel(ch2); };
    }, [selectedChannel, loadReactions, loadSubCount]);
    const react = useCallback(async (type) => {
        if (!session) { onRequireAuth('Войдите, чтобы ставить оценки'); return; }
        const prev = userReaction;
        const next = prev === type ? null : type;
        if (next === 'like') { setLikes(v => v + 1); if (prev === 'dislike') setDislikes(v => Math.max(0, v - 1)); }
        else if (next === 'dislike') { setDislikes(v => v + 1); if (prev === 'like') setLikes(v => Math.max(0, v - 1)); }
        else { if (prev === 'like') setLikes(v => Math.max(0, v - 1)); else setDislikes(v => Math.max(0, v - 1)); }
        setUserReaction(next);
        if (next) await supabase.from('channel_reactions').upsert({ channel_id: selectedChannel.id, user_id: uid, reaction: next }, { onConflict: 'channel_id,user_id' });
        else await supabase.from('channel_reactions').delete().eq('channel_id', selectedChannel.id).eq('user_id', uid);
    }, [session, selectedChannel, uid, userReaction, onRequireAuth]);
    const [bellOpen, setBellOpen] = useState(false);
    const [notifMode, setNotifMode] = useState('all');
    const [shareOpen, setShareOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [emojiOpen, setEmojiOpen] = useState(false);
    const [tab, setTab] = useState('chat');
    const [day, setDay] = useState('Понедельник');
    const [descExp, setDescExp] = useState(false);
    const playerRef = useRef(null);
    const videoRef = useRef(null);
    const bellRef = useRef(null);
    const shareRef = useRef(null);
    const emojiRef = useRef(null);
    const draggable = useCallback((ref) => ({
        onMouseDown: (e) => {
            if (e.target.closest('button,input,textarea,a,select')) return;
            e.preventDefault();
            const el = ref.current;
            if (!el) return;
            let lx = e.clientX, ly = e.clientY, cx = parseFloat(el.dataset.dx || '0'), cy = parseFloat(el.dataset.dy || '0');
            document.body.style.userSelect = 'none';
            const mv = (ev) => { cx += ev.clientX - lx; cy += ev.clientY - ly; lx = ev.clientX; ly = ev.clientY; el.dataset.dx = cx; el.dataset.dy = cy; el.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)'; };
            const up = () => { document.body.style.userSelect = ''; window.removeEventListener('mousemove', mv); window.removeEventListener('mouseup', up); };
            window.addEventListener('mousemove', mv);
            window.addEventListener('mouseup', up);
        }
    }), []);
    useEffect(() => {
        const video = videoRef.current;
        if (!video || isOffline) return;
        let hls = null;
        if (isHls && Hls.isSupported()) {
            hls = new Hls({ maxBufferLength: 10, maxMaxBufferLength: 30, liveSyncDurationCount: 1, liveMaxLatencyDurationCount: 2, capLevelToPlayerSize: false, testBandwidth: true });
            hlsRef.current = hls;
            hls.loadSource(streamUrl);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, () => { setLevels(hls.levels.map((l, i) => ({ i: i, h: l.height }))); if (autoplay) video.play().catch(() => {}); });
            hls.on(Hls.Events.ERROR, () => {});
        } else if (isHls && video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = streamUrl;
            if (autoplay) video.play().catch(() => {});
        } else {
            video.src = streamUrl;
            if (autoplay) video.play().catch(() => {});
        }
        return () => { if (hls) hls.destroy(); hlsRef.current = null; };
    }, [streamUrl, isOffline, isHls, autoplay]);
    useEffect(() => {
        if (isOffline) return;
        const iv = setInterval(() => {
            const vid = videoRef.current; const g = glowRef.current;
            if (!vid || !g || vid.readyState < 2) return;
            try {
                const c = document.createElement('canvas'); c.width = 8; c.height = 8;
                const ctx = c.getContext('2d');
                ctx.drawImage(vid, 0, 0, 8, 8);
                const d = ctx.getImageData(0, 0, 8, 8).data;
                const pick = (x, y) => { const i = (y * 8 + x) * 4; return d[i] + ',' + d[i + 1] + ',' + d[i + 2]; };
                const c1 = pick(1, 1), c2 = pick(6, 1), c3 = pick(6, 6), c4 = pick(1, 6);
                g.style.background = 'radial-gradient(circle at 20% 30%, rgba(' + c1 + ',0.5), transparent 45%), radial-gradient(circle at 80% 25%, rgba(' + c2 + ',0.5), transparent 45%), radial-gradient(circle at 60% 80%, rgba(' + c3 + ',0.45), transparent 45%), radial-gradient(circle at 30% 75%, rgba(' + c4 + ',0.35), transparent 45%)';
            } catch (e) {}
        }, 1200);
        return () => clearInterval(iv);
    }, [isOffline, streamUrl]);
    const setQualityOption = useCallback((opt) => {
        setQualityOpen(false);
        setQuality(opt.label);
        const hls = hlsRef.current;
        if (!hls) return;
        let lv = levels.find(l => l.h === opt.h);
        if (!lv) { const sorted = [...levels].sort((a, b) => a.h - b.h); lv = sorted.filter(l => l.h <= opt.h).pop() || sorted[0]; }
        if (lv) hls.currentLevel = lv.i; else hls.currentLevel = -1;
    }, [levels]);
    const setQualityAuto = useCallback(() => { setQualityOpen(false); setQuality('Авто'); const hls = hlsRef.current; if (hls) hls.currentLevel = -1; }, []);
    const togglePlay = useCallback(() => { const v = videoRef.current; if (!v) return; if (isPlaying) v.pause(); else v.play().catch(() => {}); }, [isPlaying]);
    const setVol = useCallback((n) => {
        const v = Math.max(0, Math.min(100, n));
        setVolume(v);
        const vid = videoRef.current;
        if (!vid) return;
        vid.volume = v / 100;
        if (v > 0) { vid.muted = false; setIsMuted(false); } else { vid.muted = true; setIsMuted(true); }
    }, []);
    const toggleMute = useCallback(() => {
        const vid = videoRef.current;
        if (!vid) return;
        const n = !isMuted;
        setIsMuted(n);
        vid.muted = n;
        if (n) setVolume(0); else { const rv = volume === 0 ? 100 : volume; setVolume(rv); vid.volume = rv / 100; }
    }, [isMuted, volume]);
    const toggleFullscreen = useCallback(() => {
        const el = playerRef.current;
        const vid = videoRef.current;
        const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
        if (!fsEl) {
            if (el && el.requestFullscreen) el.requestFullscreen().catch(() => {});
            else if (el && el.webkitRequestFullscreen) el.webkitRequestFullscreen();
            else if (vid && vid.webkitEnterFullscreen) vid.webkitEnterFullscreen();
        } else {
            if (document.exitFullscreen) document.exitFullscreen().catch(() => {});
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
        }
    }, []);
    useEffect(() => {
        const kd = (e) => {
            const t = document.activeElement ? document.activeElement.tagName : '';
            if (['INPUT', 'TEXTAREA', 'SELECT'].includes(t)) return;
            const k = e.key.toLowerCase();
            if (k === 'm' || k === 'ь') { e.preventDefault(); toggleMute(); }
            else if (k === 'f' || k === 'а') { e.preventDefault(); toggleFullscreen(); }
            else if (e.code === 'Space') { e.preventDefault(); togglePlay(); }
        };
        window.addEventListener('keydown', kd);
        return () => window.removeEventListener('keydown', kd);
    }, [toggleMute, toggleFullscreen, togglePlay]);
    const days = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
    const sched = schedules[selectedChannel ? selectedChannel.id : null] || {};
    const currentDayItems = useMemo(() => sched[day] || [], [sched, day]);
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState('');
    const [reply, setReply] = useState(null);
    const [editId, setEditId] = useState(null);
    const [clearCount, setClearCount] = useState(null);
    const [avatarMap, setAvatarMap] = useState({});
    const [titlesMap, setTitlesMap] = useState({});
    const endRef = useRef(null);
    const sysId = useRef(1);
    useEffect(() => {
        const ch = supabase.channel('chat_profiles_watch').on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'profiles' }, (pl) => {
            const uid_updated = pl.new.id; const newTitle = pl.new.title;
            setTitlesMap(prev => { if (prev[uid_updated] === newTitle) return prev; return { ...prev, [uid_updated]: newTitle }; });
        }).subscribe();
        return () => { supabase.removeChannel(ch); };
    }, []);
    useEffect(() => {
        if (!selectedChannel) return;
        let active = true;
        (async () => {
            const { data } = await supabase.from('chat_messages').select('*').eq('channel_id', selectedChannel.id).order('created_at', { ascending: true }).limit(200);
            if (active && data) setMessages(data.map(mapMessage));
        })();
        const ch = supabase.channel('chat_' + selectedChannel.id).on('postgres_changes', { event: '*', schema: 'public', table: 'chat_messages', filter: 'channel_id=eq.' + selectedChannel.id }, (pl) => {
            if (pl.eventType === 'INSERT') setMessages(prev => prev.some(m => m.id === pl.new.id) ? prev : [...prev, mapMessage(pl.new)]);
            else if (pl.eventType === 'UPDATE') setMessages(prev => prev.map(m => m.id === pl.new.id ? mapMessage(pl.new) : m));
            else if (pl.eventType === 'DELETE') setMessages(prev => prev.filter(m => m.id !== pl.old.id));
        }).subscribe();
        const cmd = supabase.channel('cmds_' + selectedChannel.id).on('broadcast', { event: 'clear' }, () => startClearLocal()).subscribe();
        return () => { active = false; supabase.removeChannel(ch); supabase.removeChannel(cmd); };
    }, [selectedChannel]);
    useEffect(() => { if (endRef.current) endRef.current.scrollIntoView({ behavior: 'smooth' }); }, [messages]);
    useEffect(() => {
        const ids = [];
        messages.forEach(m => { if (m.userId && ids.indexOf(m.userId) === -1) ids.push(m.userId); });
        if (!ids.length) return;
        supabase.from('profiles').select('id, avatar_url, title').in('id', ids).then(r => {
            if (r.data) {
                const m = {}; const t = {};
                r.data.forEach(p => { m[p.id] = p; t[p.id] = p.title; });
                setAvatarMap(prev => Object.assign({}, prev, m));
                setTitlesMap(prev => Object.assign({}, prev, t));
            }
        });
    }, [messages.length]);
    const startClearLocal = useCallback(() => {
        setClearCount(5);
        let n = 5;
        const iv = setInterval(() => {
            n -= 1;
            if (n <= 0) { clearInterval(iv); setClearCount(null); setMessages([{ id: 'sys' + (sysId.current++), isSystem: true, text: '🧹 Чат был очищен администратором!' }]); }
            else setClearCount(n);
        }, 1000);
    }, []);
    const send = useCallback(async (e) => {
        e.preventDefault();
        const t0 = text.trim();
        if (!t0) return;
        const isClearCmd = t0.toLowerCase().indexOf('/очист') === 0 || t0.toLowerCase().indexOf('/clear') === 0;
        if (isClearCmd) {
            if (!isAdmin) { toast('Очищать чат может только администратор'); setText(''); return; }
            setText('');
            startClearLocal();
            supabase.channel('cmds_' + selectedChannel.id).send({ type: 'broadcast', event: 'clear', payload: {} });
            await supabase.from('chat_messages').delete().eq('channel_id', selectedChannel.id);
            return;
        }
        if (!session) { onRequireAuth('Войдите, чтобы писать в чат'); return; }
        if (editId) {
            let { error } = await supabase.from('chat_messages').update({ text: t0, is_edited: true }).eq('id', editId);
            if (error) {
                const r2 = await supabase.from('chat_messages').update({ text: t0 }).eq('id', editId);
                error = r2.error;
            }
            if (error) {
                toast('Не удалось изменить сообщение');
            } else {
                setMessages(prev => prev.map(m => m.id === editId ? Object.assign({}, m, { text: t0, isEdited: true }) : m));
            }
            setEditId(null);
        } else {
            const replyPayload = reply ? JSON.stringify({ user: reply.user, text: reply.text, userId: reply.userId }) : null;
            const { data } = await supabase.from('chat_messages').insert({ channel_id: selectedChannel.id, user_id: uid, username: displayName, text: t0, reply_to: replyPayload }).select().single();
            if (data) setMessages(prev => prev.some(m => m.id === data.id) ? prev : [...prev, mapMessage(data)]);
            if (reply && reply.userId && reply.userId !== uid) {
                supabase.from('notifications').insert({ user_id: reply.userId, text: displayName + ' ответил(а) вам в чате', type: 'reply', channel_id: selectedChannel.id }).then(() => {});
            }
            setReply(null);
        }
        setText('');
    }, [text, isAdmin, session, editId, reply, selectedChannel, uid, displayName, toast, onRequireAuth, startClearLocal]);
    const delMsg = useCallback(async (id) => {
        setMessages(prev => prev.map(m => m.id === id ? Object.assign({}, m, { isDeleted: true, deletedBy: 'user' }) : m));
        await supabase.from('chat_messages').update({ is_deleted: true, deleted_by: 'user' }).eq('id', id);
    }, []);
    const adminToggleMsg = useCallback(async (msg) => {
        const nd = !msg.isDeleted;
        setMessages(prev => prev.map(m => m.id === msg.id ? Object.assign({}, m, { isDeleted: nd, deletedBy: nd ? 'admin' : null }) : m));
        await supabase.from('chat_messages').update({ is_deleted: nd, deleted_by: nd ? 'admin' : null }).eq('id', msg.id);
    }, []);
    const shareUrl = window.location.origin + '/?channel=' + (selectedChannel ? selectedChannel.name : 'LiveNet');
    const copyLink = useCallback(async () => {
        try { await navigator.clipboard.writeText(shareUrl); } catch (e) {}
        setCopied(true);
        setTimeout(() => { setCopied(false); setShareOpen(false); }, 1200);
    }, [shareUrl]);
    const desc = selectedChannel ? selectedChannel.desc : 'Прямая трансляция телеканала в высоком качестве.';
    const longDesc = (desc || '').length > 120;
    const hideCtrl = isPlaying && !controlsVisible;
    const isSub = subscriptions.includes(selectedChannel ? selectedChannel.id : null);
    const showClearHint = isAdmin && (text.trim().toLowerCase().indexOf('/очи') === 0 || text.trim().toLowerCase().indexOf('/cle') === 0);
    const getUserTitleGradient = useCallback((userId) => {
        const titleId = titlesMap[userId];
        if (!titleId) return null;
        const title = TITLES.find(t => t.id === titleId);
        return title ? title.gradient : null;
    }, [titlesMap]);

    if (selectedChannel && selectedChannel.maintenance && !isAdmin) {
        return (
            <div className="section-container" style={{ padding: '30px 20px', maxWidth: '1440px', margin: '0 auto' }}>
                <div style={{ position: 'relative', minHeight: '70vh', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 25px 60px rgba(0,0,0,0.5)' }}>
                    <ChannelMaintenanceScreen channel={selectedChannel} onBack={() => setCurrentRoute('channels')} />
                </div>
            </div>
        );
    }

    return (
        <div className="section-container" style={{ padding: '30px 20px', maxWidth: '1440px', margin: '0 auto' }}>
            <button className="btn-ghost" onClick={() => setCurrentRoute('channels')} style={{ marginBottom: '20px' }}>← Назад к каналам</button>
            <div className="player-layout-grid" style={{ display: 'grid', gridTemplateColumns: showChat ? '1fr 420px' : '1fr', gap: '30px', alignItems: 'start' }}>
                <div>
                    <div style={{ position: 'relative' }}>
                        {!isOffline && <div ref={glowRef} className="ambilight-glow"></div>}
                        <div ref={playerRef} className={'youtube-player-container ' + (hideCtrl ? 'hide-cursor' : '')} onMouseMove={reveal} style={{ position: 'relative', width: '100%', aspectRatio: '16/9', background: '#05070c', borderRadius: '20px', overflow: 'hidden', border: '1px solid var(--border-color)', boxShadow: '0 25px 60px rgba(0,0,0,0.7)', zIndex: 1 }}>
                            {isOffline ? (
                                <div className="player-offline">
                                    <div className="offline-emoji">🌙</div>
                                    <h2>Увы, но эфира сейчас нет</h2>
                                    <p>Канал временно не в эфире. Подпишись и включи колокольчик, чтобы не пропустить трансляцию!</p>
                                </div>
                            ) : (
                                <React.Fragment>
                                    <video ref={videoRef} loop playsInline style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'relative', zIndex: 1 }} onClick={togglePlay} onPlay={() => setIsPlaying(true)} onPause={() => setIsPlaying(false)} />
                                    {!isPlaying && (
                                        <div className="player-pause-overlay" onClick={togglePlay}>
                                            <div className="pause-play-btn">
                                                <svg width="38" height="38" viewBox="0 0 24 24" fill="currentColor" style={{ marginLeft: '4px' }}><polygon points="5 3 19 12 5 21 5 3" /></svg>
                                            </div>
                                            <span>Эфир на паузе</span>
                                        </div>
                                    )}
                                    <div className="youtube-player-controls" style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(2,6,15,0.95))', padding: '25px 25px 18px 25px', display: 'flex', flexDirection: 'column', gap: '12px', zIndex: 5, opacity: controlsVisible ? 1 : 0, pointerEvents: controlsVisible ? 'auto' : 'none', transition: 'opacity 0.3s ease' }}>
                                        <div style={{ width: '100%', height: '5px', background: 'rgba(255,255,255,0.15)', borderRadius: '3px', overflow: 'hidden' }}>
                                            <div style={{ width: '100%', height: '100%', background: 'var(--accent-primary)', borderRadius: '3px', boxShadow: '0 0 10px var(--accent-primary)' }}></div>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                                                <button onClick={togglePlay} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
                                                    {isPlaying ? <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></svg> : <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3" /></svg>}
                                                </button>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <button onClick={toggleMute} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
                                                        {isMuted || volume === 0 ? <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" /><line x1="23" y1="9" x2="17" y2="15" /><line x1="17" y1="9" x2="23" y2="15" /></svg> : <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" /></svg>}
                                                    </button>
                                                    <input type="range" min="0" max="100" value={volume} onChange={(e) => setVol(Number(e.target.value))} style={{ width: '80px', cursor: 'pointer', accentColor: 'var(--accent-primary)' }} />
                                                    <span style={{ fontSize: '13px', color: '#fff', fontWeight: '600', minWidth: '38px' }}>{volume}%</span>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                                {isHls && (
                                                    <div style={{ position: 'relative' }}>
                                                        <button onClick={() => setQualityOpen(!qualityOpen)} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', padding: '6px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                            {quality}
                                                            {(quality === '4K' || quality === '1080p') && <span style={{ background: '#ef4444', color: '#fff', fontSize: '9px', fontWeight: '800', padding: '1px 4px', borderRadius: '3px' }}>HD</span>}
                                                            ⚙️
                                                        </button>
                                                        {qualityOpen && (
                                                            <div className="quality-menu" style={{ position: 'absolute', bottom: '42px', right: 0, background: '#13151b', border: '1px solid var(--border-color)', borderRadius: '12px', padding: '8px', display: 'flex', flexDirection: 'column', gap: '4px', zIndex: 10, minWidth: '140px', boxShadow: '0 10px 30px rgba(0,0,0,0.6)' }}>
                                                                <button onClick={setQualityAuto} style={{ background: quality === 'Авто' ? 'rgba(0,245,160,0.15)' : 'transparent', color: quality === 'Авто' ? 'var(--accent-primary)' : '#fff', border: 'none', padding: '8px 12px', textAlign: 'left', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '600' }}>Авто</button>
                                                                {QUALITY_OPTIONS.map(opt => (
                                                                    <button key={opt.label} onClick={() => setQualityOption(opt)} style={{ background: quality === opt.label ? 'rgba(0,245,160,0.15)' : 'transparent', color: quality === opt.label ? 'var(--accent-primary)' : '#fff', border: 'none', padding: '8px 12px', textAlign: 'left', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        {opt.label}
                                                                        {opt.hd && <span style={{ background: '#ef4444', color: '#fff', fontSize: '9px', fontWeight: '800', padding: '1px 4px', borderRadius: '3px' }}>HD</span>}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                <button onClick={toggleFullscreen} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
                                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" /></svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                    <div style={{ marginTop: '24px' }}>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                            {selectedChannel && selectedChannel.isOfficial && <span style={{ background: '#ef4444', color: '#fff', fontSize: '11px', fontWeight: '800', padding: '3px 10px', borderRadius: '6px' }}>Официальный канал</span>}
                            {selectedChannel && selectedChannel.isPartner && <span style={{ background: 'rgba(0,245,160,0.2)', color: 'var(--accent-primary)', fontSize: '11px', fontWeight: '700', padding: '3px 10px', borderRadius: '6px' }}>Партнер</span>}
                            {selectedChannel && selectedChannel.isAd && <span style={{ background: '#f59e0b', color: '#000', fontSize: '11px', fontWeight: '700', padding: '3px 10px', borderRadius: '6px' }}>Реклама</span>}
                            <span className={'stat-chip ' + (onlineNow > 0 ? 'live' : '')}>👁 <b>{onlineNow}</b> смотрят</span>
                            <span className="stat-chip">🔔 <b>{subCount}</b> подписчиков</span>
                        </div>
                        <h1 style={{ fontSize: '2.1rem', fontWeight: '900', letterSpacing: '-0.5px', marginBottom: '12px' }}>{selectedChannel ? selectedChannel.name : 'LiveNet Stream'}</h1>
                        <div className="player-actions-row">
                            <div style={{ display: 'flex', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: '14px', overflow: 'hidden' }}>
                                <button onClick={() => react('like')} style={{ background: userReaction === 'like' ? '#22c55e' : 'transparent', color: userReaction === 'like' ? '#fff' : 'var(--text-main)', border: 'none', padding: '10px 16px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill={userReaction === 'like' ? '#fff' : 'none'} stroke="currentColor" strokeWidth="2"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>
                                    <span>{likes}</span>
                                </button>
                                <div style={{ width: '1px', background: 'var(--border-color)' }}></div>
                                <button onClick={() => react('dislike')} style={{ background: userReaction === 'dislike' ? '#ef4444' : 'transparent', color: userReaction === 'dislike' ? '#fff' : 'var(--text-main)', border: 'none', padding: '10px 14px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill={userReaction === 'dislike' ? '#fff' : 'none'} stroke="currentColor" strokeWidth="2"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path></svg>
                                    <span>{dislikes}</span>
                                </button>
                            </div>
                            <button onClick={() => toggleSubscription(selectedChannel ? selectedChannel.id : null)} className={'subscribe-btn-fixed ' + (isSub ? 'subscribed' : 'unsubscribed')}>{isSub ? '✓ Вы подписаны' : '+ Подписаться'}</button>
                            {isSub && (
                                <div style={{ position: 'relative' }}>
                                    <button onClick={() => setBellOpen(!bellOpen)} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: 'var(--accent-primary)', width: '44px', height: '44px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                        {notifMode === 'none' ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg> : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>}
                                    </button>
                                    {bellOpen && (
                                        <div {...draggable(bellRef)} ref={bellRef} className="float-popup" style={{ width: '230px', padding: '14px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                                <span style={{ fontSize: '13px', fontWeight: '800' }}>Уведомления канала</span>
                                                <button type="button" className="popup-x" onMouseDown={(e) => e.stopPropagation()} onClick={() => setBellOpen(false)}>✕</button>
                                            </div>
                                            <button onClick={() => { setNotifMode('all'); setBellOpen(false); }} style={{ width: '100%', textAlign: 'left', padding: '8px 10px', background: notifMode === 'all' ? 'rgba(0,245,160,0.1)' : 'transparent', color: notifMode === 'all' ? 'var(--accent-primary)' : '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', marginBottom: '4px' }}>✓ Получать все</button>
                                            <button onClick={() => { setNotifMode('none'); setBellOpen(false); }} style={{ width: '100%', textAlign: 'left', padding: '8px 10px', background: notifMode === 'none' ? 'rgba(239,68,68,0.1)' : 'transparent', color: notifMode === 'none' ? '#ef4444' : '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>✕ Не получать</button>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div style={{ position: 'relative' }}>
                                <button onClick={() => setShareOpen(!shareOpen)} className="icon-btn" style={{ width: '44px', height: '44px', borderRadius: '14px' }} title="Поделиться">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
                                </button>
                                {shareOpen && (
                                    <div {...draggable(shareRef)} ref={shareRef} className="float-popup" style={{ width: '260px', padding: '14px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                            <span style={{ fontSize: '13px', fontWeight: '800' }}>Ссылка на эфир</span>
                                            <button type="button" className="popup-x" onMouseDown={(e) => e.stopPropagation()} onClick={() => setShareOpen(false)}>✕</button>
                                        </div>
                                        <input type="text" readOnly value={shareUrl} className="admin-input" style={{ padding: '8px 10px', fontSize: '12px', marginBottom: '10px', background: 'rgba(0,0,0,0.4)', width: '100%' }} />
                                        <button onClick={copyLink} style={{ width: '100%', padding: '10px 12px', background: copied ? '#10b981' : 'var(--accent-primary)', color: copied ? '#fff' : '#000', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>{copied ? '✓ Скопировано!' : 'Скопировать ссылку'}</button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={'player-desc ' + (!descExp && longDesc ? 'clamped' : '')}>
                            <p>{desc}</p>
                            {!descExp && longDesc && <div className="desc-fade"></div>}
                        </div>
                        {longDesc && <button className="desc-toggle" onClick={() => setDescExp(!descExp)}>{descExp ? '▲ Свернуть' : '▼ Развернуть'}</button>}
                    </div>
                </div>
                {showChat && (
                    <div style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: '20px', display: 'flex', flexDirection: 'column', height: '650px', overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }}>
                        <div style={{ display: 'flex', borderBottom: '1px solid var(--border-color)', flexShrink: 0 }}>
                            <button onClick={() => setTab('chat')} style={{ flex: 1, padding: '16px', background: tab === 'chat' ? 'rgba(0,245,160,0.08)' : 'transparent', color: tab === 'chat' ? 'var(--accent-primary)' : 'var(--text-muted)', border: 'none', fontWeight: '800', cursor: 'pointer', fontSize: '14px' }}>💬 Онлайн чат</button>
                            <button onClick={() => setTab('schedule')} style={{ flex: 1, padding: '16px', background: tab === 'schedule' ? 'rgba(0,245,160,0.08)' : 'transparent', color: tab === 'schedule' ? 'var(--accent-primary)' : 'var(--text-muted)', border: 'none', fontWeight: '800', cursor: 'pointer', fontSize: '14px' }}>📅 Расписание</button>
                        </div>
                        {tab === 'schedule' && (
                            <div className="schedule-scroll">
                                <div className="sched-sticky-top">
                                    <h4 className="sched-week-title">Сетка вещания на неделю</h4>
                                    <div className="day-strip">{days.map((d) => <button key={d} onClick={() => setDay(d)} className={'day-chip ' + (day === d ? 'active' : '')}>{d}</button>)}</div>
                                </div>
                                <div className="sched-content">
                                    <div className="sched-day-label">📌 {day}</div>
                                    {currentDayItems.length > 0 ? (
                                        <div className="sched-timeline">{currentDayItems.map((it, i) => (
                                            <div key={it.id + '-' + i} className="sched-item">
                                                <div className="sched-time">{it.time || '—'}</div>
                                                <div className="sched-card"><h4>{it.title}</h4></div>
                                            </div>
                                        ))}</div>
                                    ) : (
                                        <div className="sched-empty">На этот день расписание еще не заполнено.</div>
                                    )}
                                </div>
                            </div>
                        )}
                        {tab === 'chat' && (
                            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden', position: 'relative' }}>
                                <div className="chat-messages" style={{ flex: 1, minHeight: 0, padding: '16px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {messages.map((msg) => {
                                        const isMine = msg.userId != null && msg.userId === uid;
                                        if (msg.isSystem) return <div key={msg.id} className="chat-system-msg">{msg.text}</div>;
                                        const repliedToMe = msg.replyTo && msg.replyTo.userId && msg.replyTo.userId === uid;
                                        const highlighted = repliedToMe || (highlightUser && msg.user === highlightUser);
                                        const prof = msg.userId ? avatarMap[msg.userId] : null;
                                        const av = (prof && prof.avatar_url) ? prof.avatar_url : DEFAULT_AVATAR;
                                        const titleGradient = getUserTitleGradient(msg.userId);
                                        return (
                                            <div key={msg.id} className="chat-row">
                                                <img className="chat-avatar" src={av} alt=" " onClick={() => openUserProfile(msg.userId, isMine)} style={{ cursor: 'pointer' }} />
                                                <div className={'chat-bubble ' + (highlighted ? 'replied-to-me' : '')}>
                                                    <div className="chat-bubble-head">
                                                        <span className="chat-nick" onClick={() => openUserProfile(msg.userId, isMine)} title="Профиль" style={titleGradient ? { background: titleGradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' } : {}}>{msg.user}</span>
                                                        <span className="chat-time">{msg.time}{msg.isEdited ? ' · изм.' : ''}</span>
                                                    </div>
                                                    {msg.replyTo && <div className="chat-reply">↩ {msg.replyTo.user}: {msg.replyTo.text}</div>}
                                                    <p className={'chat-text ' + (msg.isDeleted ? 'deleted' : '')}>
                                                        {msg.isDeleted ? (msg.deletedBy === 'admin' ? ('Сообщение удалено администратором' + (isAdmin ? ' [' + msg.text + ']' : '')) : 'Сообщение удалено пользователем') : msg.text}
                                                    </p>
                                                    <div className="chat-actions">
                                                        {!msg.isDeleted && !isMine && session && <button onClick={() => setReply(msg)}>↩ Ответить</button>}
                                                        {!msg.isDeleted && isMine && <button onClick={() => { setEditId(msg.id); setText(msg.text); setReply(null); }}>✏️ Изменить</button>}
                                                        {!msg.isDeleted && isMine && <button className="del" onClick={() => delMsg(msg.id)}>🗑️ Удалить</button>}
                                                        {isAdmin && <button className="del" onClick={() => adminToggleMsg(msg)}>🛡️ {msg.isDeleted ? 'Вернуть' : 'Удалить'}</button>}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <div ref={endRef}></div>
                                </div>
                                {emojiOpen && (
                                    <div {...draggable(emojiRef)} ref={emojiRef} className="float-popup float-popup-emoji" style={{ padding: '16px', width: '260px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                            <span style={{ fontSize: '12px', fontWeight: '800', color: 'var(--text-muted)' }}>Эмодзи</span>
                                            <button type="button" className="popup-x" onMouseDown={(e) => e.stopPropagation()} onClick={() => setEmojiOpen(false)}>✕</button>
                                        </div>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: '8px', fontSize: '20px' }}>
                                            {EMOJIS.map((em) => (
                                                <button key={em} onClick={() => setText(p => p + em)} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '6px', cursor: 'pointer' }}>{em}</button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {clearCount !== null && <div className="clear-countdown">⏳ Очистка чата через {clearCount}...</div>}
                                {reply && (
                                    <div style={{ padding: '8px 14px', background: 'rgba(0,245,160,0.1)', borderTop: '1px solid var(--border-color)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', flexShrink: 0 }}>
                                        <span>Ответ: <strong>{reply.user}</strong></span>
                                        <button onClick={() => setReply(null)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontWeight: 'bold' }}>✕</button>
                                    </div>
                                )}
                                {showClearHint && <div className="clear-hint">↵ Enter — очистить чат (таймер 5 сек)</div>}
                                {session ? (
                                    <form onSubmit={send} style={{ padding: '14px', borderTop: '1px solid var(--border-color)', display: 'flex', gap: '10px', alignItems: 'center', flexShrink: 0 }}>
                                        <button type="button" onClick={() => setEmojiOpen(!emojiOpen)} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: 'var(--accent-primary)', borderRadius: '10px', width: '42px', height: '42px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '18px', flexShrink: 0 }}>😊</button>
                                        <input type="text" placeholder={isAdmin ? 'Сообщение или /очистить...' : 'Написать сообщение...'} value={text} onChange={(e) => setText(e.target.value)} className="admin-input" style={{ margin: 0, flex: 1, padding: '12px 16px', fontSize: '13px' }} />
                                        <button type="submit" className="btn-primary" style={{ padding: '12px 18px', fontSize: '13px' }}>{editId ? 'Ок' : 'Отправить'}</button>
                                    </form>
                                ) : (
                                    <div className="chat-login-prompt">
                                        <p>Войдите, чтобы писать в чат</p>
                                        <button className="btn-primary" onClick={() => onRequireAuth('Войдите, чтобы писать в чат')}>Войти / Регистрация</button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

const ProfilePage = ({ session, userProfile, profileExtras, subscriptions, viewingUserId, setCurrentRoute, onOpenAuth, previousRoute }) => {
    const [viewProfile, setViewProfile] = useState(null);
    const [followers, setFollowers] = useState(0);
    const [isFollowing, setIsFollowing] = useState(false);
    const myId = session ? session.user.id : null;
    const isSelf = !viewingUserId || viewingUserId === myId;
    const loadFollows = useCallback(() => {
        const target = isSelf ? myId : viewingUserId;
        if (!target) return;
        supabase.from('user_follows').select('*', { count: 'exact', head: true }).eq('followee_id', target).then(r => setFollowers(r.count || 0));
        if (myId && !isSelf) supabase.from('user_follows').select('id').eq('follower_id', myId).eq('followee_id', viewingUserId).maybeSingle().then(r => setIsFollowing(!!r.data));
    }, [isSelf, myId, viewingUserId]);
    useEffect(() => {
        if (isSelf) { setViewProfile(null); loadFollows(); return; }
        let active = true;
        (async () => {
            const { data } = await supabase.from('profiles').select('*').eq('id', viewingUserId).maybeSingle();
            if (active) setViewProfile(data);
            loadFollows();
        })();
        return () => { active = false; };
    }, [viewingUserId, isSelf, loadFollows]);
    useEffect(() => {
        const ch = supabase.channel('follows_watch').on('postgres_changes', { event: '*', schema: 'public', table: 'user_follows' }, () => { loadFollows(); }).subscribe();
        return () => { supabase.removeChannel(ch); };
    }, [loadFollows]);
    useEffect(() => {
        const targetId = isSelf ? myId : viewingUserId;
        if (!targetId) return;
        const ch = supabase.channel('profile_title_live').on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'profiles' }, (pl) => {
            if (pl.new.id === targetId) setViewProfile(prev => prev ? Object.assign({}, prev, { title: pl.new.title }) : prev);
        }).subscribe();
        return () => { supabase.removeChannel(ch); };
    }, [isSelf, myId, viewingUserId]);
    const toggleFollow = async () => {
        if (!session) { onOpenAuth('login'); return; }
        if (isFollowing) {
            await supabase.from('user_follows').delete().eq('follower_id', myId).eq('followee_id', viewingUserId);
            setIsFollowing(false);
            setFollowers(v => Math.max(0, v - 1));
        } else {
            await supabase.from('user_follows').insert({ follower_id: myId, followee_id: viewingUserId });
            setIsFollowing(true);
            setFollowers(v => v + 1);
        }
    };
    if (!session && isSelf) {
        return (
            <div className="section-container page-shell">
                <div className="empty-state-card glow-effect">
                    <div className="empty-icon">👤</div>
                    <h2>Профиль недоступен</h2>
                    <p>Войдите в аккаунт LiveNet.</p>
                    <button className="btn-primary" onClick={() => onOpenAuth('login')}>Войти</button>
                </div>
            </div>
        );
    }
    let name, username, avatar, banner, bio, bioPrivate, titleId;
    if (isSelf) {
        name = profileExtras.displayName || (userProfile ? userProfile.display_name : '') || 'LiveNet User';
        username = profileExtras.username || (userProfile ? userProfile.username : '') || 'livenet_user';
        avatar = profileExtras.avatar || (userProfile ? userProfile.avatar_url : '') || DEFAULT_AVATAR;
        banner = profileExtras.banner || null;
        bio = profileExtras.bio || 'Вы пока не добавили описание.';
        bioPrivate = !!profileExtras.bioPrivate;
        titleId = userProfile ? userProfile.title : null;
    } else if (viewProfile) {
        name = viewProfile.display_name || 'LiveNet User';
        username = viewProfile.username || 'user';
        avatar = viewProfile.avatar_url || DEFAULT_AVATAR;
        banner = viewProfile.banner_url || null;
        bio = viewProfile.bio || 'Этот пользователь не добавил описание.';
        bioPrivate = !!viewProfile.bio_private;
        titleId = viewProfile.title;
    } else {
        name = '...'; username = '...'; avatar = DEFAULT_AVATAR; banner = null; bio = ''; bioPrivate = false; titleId = null;
    }
    const bannerStyle = banner ? { backgroundImage: 'url(' + banner + ')', backgroundSize: 'cover', backgroundPosition: 'center' } : {};
    return (
        <div className="section-container page-shell">
            {previousRoute === 'admin' && (
                <button className="btn-ghost" onClick={() => setCurrentRoute('admin')} style={{ marginBottom: '20px' }}>← Назад в админ-панель</button>
            )}
            <div className="profile-banner" style={bannerStyle}>{!banner && isSelf && <div className="profile-banner-pattern"></div>}</div>
            <div className="profile-header-row">
                <img src={avatar} alt="Avatar" className="profile-avatar-xl" />
                <div className="profile-channel-info">
                    <h1 style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>{name}{titleId && <TitleBadge titleId={titleId} size="md" />}</h1>
                    <div className="profile-channel-meta">
                        <span className="profile-username">@{username}</span>
                        <span className="meta-dot">•</span>
                        <span className="subscribers-count">Подписчиков: {followers}</span>
                    </div>
                    <div style={{ marginTop: '14px' }}>
                        {isSelf ? (
                            <button className="btn-ghost" onClick={() => setCurrentRoute('settings')}>✏️ Редактировать профиль</button>
                        ) : (
                            <button onClick={toggleFollow} className={'subscribe-btn-fixed ' + (isFollowing ? 'subscribed' : 'unsubscribed')}>{isFollowing ? '✓ Вы подписаны' : '+ Подписаться'}</button>
                        )}
                    </div>
                </div>
            </div>
            <div className="about-section">
                <h3>О себе {isSelf && bioPrivate ? <span title="Приватное" style={{ marginLeft: '6px' }}>🔒</span> : null}</h3>
                <p>{bioPrivate && !isSelf ? 'Описание скрыто пользователем.' : bio}</p>
            </div>
            {isSelf && (
                <div className="profile-actions">
                    <button className="btn-primary" onClick={() => setCurrentRoute('subscriptions')}>Мои подписки ({subscriptions.length})</button>
                    <button className="btn-ghost" onClick={() => setCurrentRoute('settings')}>Настройки</button>
                </div>
            )}
        </div>
    );
};

const SubscriptionsPage = ({ adminChannels, subscriptions, toggleSubscription, setSelectedChannel, setCurrentRoute, session, openUserProfile }) => {
    const subs = adminChannels.filter(c => subscriptions.includes(c.id));
    const [follows, setFollows] = useState([]);
    const myId = session ? session.user.id : null;
    useEffect(() => {
        if (!myId) { setFollows([]); return; }
        (async () => {
            const { data } = await supabase.from('user_follows').select('followee_id').eq('follower_id', myId);
            if (data && data.length) {
                const ids = data.map(r => r.followee_id);
                const { data: profs } = await supabase.from('profiles').select('*').in('id', ids);
                setFollows(profs || []);
            } else setFollows([]);
        })();
    }, [myId]);
    const unfollow = async (id) => {
        await supabase.from('user_follows').delete().eq('follower_id', myId).eq('followee_id', id);
        setFollows(p => p.filter(f => f.id !== id));
    };
    return (
        <div className="section-container page-shell">
            <div className="page-head">
                <span className="hero-badge">Подписки</span>
                <h1 className="page-title">Каналы, на которые <span className="gradient-text">вы подписаны</span></h1>
            </div>
            {subs.length > 0 ? (
                <div className="channels-grid">
                    {subs.map((c) => (
                        <div key={c.id} className="channel-card">
                            <div className="channel-card-top"><div className="channel-avatar-badge"><img src={c.image || logo} alt={c.name} /></div></div>
                            <div className="channel-card-body"><h3>{c.name}</h3><span className="channel-cat-tag">{c.category}</span><p>{c.desc}</p></div>
                            <div className="channel-card-footer sub-footer">
                                <button className="btn-primary" onClick={() => { setSelectedChannel(c); setCurrentRoute('player'); }}>Смотреть</button>
                                <button className="btn-ghost" onClick={() => toggleSubscription(c.id)}>Отписаться</button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="empty-state-card">
                    <div className="empty-icon">📡</div>
                    <h2>Пока нет подписок на каналы</h2>
                    <button className="btn-primary" onClick={() => setCurrentRoute('channels')}>К каналам</button>
                </div>
            )}
            <div className="page-head" style={{ marginTop: '50px' }}>
                <h1 className="page-title" style={{ fontSize: '1.6rem' }}>Люди, на которых <span className="gradient-text">вы подписаны</span></h1>
            </div>
            {follows.length > 0 ? (
                <div className="follows-list">
                    {follows.map((f) => (
                        <div key={f.id} className="follow-card">
                            <img src={f.avatar_url || DEFAULT_AVATAR} alt=" " className="follow-avatar" />
                            <div style={{ flex: 1 }}>
                                <h4>{f.display_name || 'Пользователь'}</h4>
                                <span className="profile-username">@{f.username || 'user'}</span>
                            </div>
                            <button className="btn-ghost mini-btn" onClick={() => openUserProfile(f.id, false)}>Профиль</button>
                            <button className="btn-ghost mini-btn danger-ghost" onClick={() => unfollow(f.id)}>Отписаться</button>
                        </div>
                    ))}
                </div>
            ) : (
                <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>Вы пока не подписаны ни на одного пользователя. Нажмите на ник в чате, чтобы открыть профиль и подписаться.</p>
            )}
        </div>
    );
};

const SettingsPage = ({ session, userProfile, profileExtras, setProfileExtras, onOpenAuth, notify, onProfileUpdated, setCurrentRoute, prefs, setPrefs, isAdmin }) => {
    const [saved, setSaved] = useState(false);
    const [name, setName] = useState(profileExtras.displayName || '');
    const [uname, setUname] = useState(profileExtras.username || '');
    const [bio, setBio] = useState(profileExtras.bio || '');
    const [msg, setMsg] = useState(null);
    const [pw, setPw] = useState('');
    const [em, setEm] = useState('');
    const [sec, setSec] = useState(null);
    const [busy, setBusy] = useState(false);
    const [exp, setExp] = useState(false);
    const [crop, setCrop] = useState(null);
    const [perm, setPerm] = useState(typeof Notification !== 'undefined' ? Notification.permission : 'unsupported');
    const [vol, setVol] = useState(prefs.notifVolume);
    const [animEnabled, setAnimEnabled] = useState(() => localStorage.getItem('ln_anim_enabled') !== 'false');
    const lastP = useRef(0);
    useEffect(() => { setVol(prefs.notifVolume); }, [prefs.notifVolume]);
    useEffect(() => { setName(profileExtras.displayName || ''); setUname(profileExtras.username || ''); setBio(profileExtras.bio || ''); }, [profileExtras]);
    const volIn = (v) => { setVol(v); const t = Date.now(); if (t - lastP.current > 350) { lastP.current = t; playNotifSound(v, prefs.notifSoundType); } };
    const volCommit = () => { setPrefs(p => Object.assign({}, p, { notifVolume: vol })); playNotifSound(vol, prefs.notifSoundType); };
    const flash = () => { setSaved(true); setTimeout(() => setSaved(false), 1500); };
    const tog = (k) => { setPrefs(p => Object.assign({}, p, { [k]: !p[k] })); flash(); };
    const toggleAnim = () => {
        setAnimEnabled(v => {
            const n = !v;
            localStorage.setItem('ln_anim_enabled', n ? 'true' : 'false');
            notify(n ? 'Анимированные аватарки включены для администрации' : 'Анимированные аватарки выключены');
            return n;
        });
    };
    const saveProfile = async () => {
        setMsg(null);
        const u = { display_name: name.trim(), username: uname.trim() || 'livenet_user', bio: bio, bio_private: !!profileExtras.bioPrivate, avatar_url: profileExtras.avatar, banner_url: profileExtras.banner };
        if (!session) { setMsg({ type: 'error', text: 'Войдите, чтобы сохранить.' }); return; }
        setBusy(true);
        try {
            const { error } = await supabase.from('profiles').update(u).eq('id', session.user.id);
            if (error) setMsg({ type: 'error', text: error.message });
            else { setMsg({ type: 'ok', text: 'Сохранено!' }); setProfileExtras(p => Object.assign({}, p, u)); onProfileUpdated(u); }
        } catch (e) { setMsg({ type: 'error', text: 'Ошибка.' }); }
        setBusy(false);
    };
    const chPw = async (e) => {
        e.preventDefault(); setSec(null);
        if (!session) { setSec({ type: 'error', text: 'Войдите.' }); return; }
        if (pw.length < 6) { setSec({ type: 'error', text: 'Минимум 6 символов.' }); return; }
        setBusy(true);
        try {
            const { error } = await supabase.auth.updateUser({ password: pw });
            if (error) setSec({ type: 'error', text: error.message });
            else { setSec({ type: 'ok', text: 'Пароль изменён!' }); setPw(''); }
        } catch (e) { setSec({ type: 'error', text: 'Ошибка.' }); }
        setBusy(false);
    };
    const chEm = async (e) => {
        e.preventDefault(); setSec(null);
        if (!session) { setSec({ type: 'error', text: 'Войдите.' }); return; }
        if (!em.trim()) { setSec({ type: 'error', text: 'Введите email.' }); return; }
        setBusy(true);
        try {
            const { error } = await supabase.auth.updateUser({ email: em.trim() });
            if (error) setSec({ type: 'error', text: error.message });
            else { setSec({ type: 'ok', text: 'Письмо отправлено.' }); setEm(''); }
        } catch (e) { setSec({ type: 'error', text: 'Ошибка.' }); }
        setBusy(false);
    };
    const reqPerm = async () => {
        if (typeof Notification === 'undefined') return;
        const r = await Notification.requestPermission();
        setPerm(r);
        if (r === 'granted') { notify('Уведомления включены! 🔔'); showBrowserNotif('LiveNet', 'Уведомления включены!', prefs); }
    };
    const testNotif = () => { notify('Тестовое уведомление LiveNet 🔔'); showBrowserNotif('LiveNet', 'Тестовое уведомление 🔔', prefs); };
    const handleLogout = async () => { await supabase.auth.signOut(); setCurrentRoute('main'); };
    return (
        <div className="section-container page-shell">
            <div className="page-head">
                <span className="hero-badge">Настройки</span>
                <h1 className="page-title">Параметры <span className="gradient-text">аккаунта</span></h1>
                <p className="page-sub">Изменения сохраняются автоматически{saved ? <span className="saved-chip">✓ Сохранено</span> : null}</p>
            </div>
            <div className="settings-section">
                <h3 className="settings-section-title"><span className="section-icon">👤</span> Профиль</h3>
                <div className="settings-card">
                    <div className="profile-edit-banner" style={profileExtras.banner ? { backgroundImage: 'url(' + profileExtras.banner + ')', backgroundSize: 'cover', backgroundPosition: 'center' } : {}}>
                        {!profileExtras.banner && <span className="banner-placeholder">Шапка профиля</span>}
                        <div className="banner-edit-btns">
                            <button className="btn-ghost mini-btn" onClick={() => setCrop('banner')}>🖼 Изменить шапку</button>
                            {profileExtras.banner && <button className="btn-ghost mini-btn danger-ghost" onClick={() => setProfileExtras(p => Object.assign({}, p, { banner: null }))}>Удалить</button>}
                        </div>
                    </div>
                    <div className="profile-edit-avatar-row">
                        <div className="profile-edit-avatar"><img src={profileExtras.avatar || (userProfile ? userProfile.avatar_url : '') || DEFAULT_AVATAR} alt="avatar" /></div>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            <button className="btn-ghost" onClick={() => setCrop('avatar')}>📷 Сменить аватар</button>
                            {profileExtras.avatar && <button className="btn-ghost danger-ghost" onClick={() => setProfileExtras(p => Object.assign({}, p, { avatar: null }))}>Удалить аватар</button>}
                        </div>
                    </div>
                    <div className="settings-form-grid">
                        <div className="settings-field">
                            <label className="auth-label">Никнейм</label>
                            <input type="text" className="admin-input" style={{ width: '100%', margin: 0 }} value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className="settings-field">
                            <label className="auth-label">Юзернейм</label>
                            <input type="text" className="admin-input" style={{ width: '100%', margin: 0 }} value={uname} onChange={(e) => setUname(e.target.value)} />
                        </div>
                    </div>
                    <div className="settings-field" style={{ marginTop: '14px' }}>
                        <label className="auth-label">О себе</label>
                        <textarea className="admin-input bio-textarea" value={bio} onChange={(e) => setBio(e.target.value)} />
                        <label className="privacy-toggle">
                            <input type="checkbox" checked={!!profileExtras.bioPrivate} onChange={() => setProfileExtras(p => Object.assign({}, p, { bioPrivate: !p.bioPrivate }))} />
                            <span>🔒 Приватное описание</span>
                        </label>
                    </div>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginTop: '16px' }}>
                        <button className="btn-primary" onClick={saveProfile} disabled={busy}>Сохранить профиль</button>
                        {msg && <span className={msg.type === 'ok' ? 'msg-ok' : 'msg-error'}>{msg.text}</span>}
                    </div>
                </div>
            </div>
            {isAdmin && (
                <div className="settings-section">
                    <h3 className="settings-section-title"><span className="section-icon">🎬</span> Служебное</h3>
                    <div className="settings-card">
                        <div className="settings-row">
                            <div>
                                <h4>Анимированные аватарки и шапки</h4>
                                <p>GIF для администрации. Обычным пользователям недоступно.</p>
                            </div>
                            <button className={'switch ' + (animEnabled ? 'on' : '')} onClick={toggleAnim}><span className="switch-knob"></span></button>
                        </div>
                    </div>
                </div>
            )}
            <div className="settings-section">
                <h3 className="settings-section-title"><span className="section-icon">▶️</span> Просмотр</h3>
                <div className="settings-list">
                    <div className="settings-row">
                        <div><h4>Автовоспроизведение</h4><p>Запускать эфир при открытии</p></div>
                        <button className={'switch ' + (prefs.autoplay ? 'on' : '')} onClick={() => tog('autoplay')}><span className="switch-knob"></span></button>
                    </div>
                    <div className="settings-row">
                        <div><h4>Онлайн чат</h4><p>Показывать чат рядом с плеером</p></div>
                        <button className={'switch ' + (prefs.chatEnabled ? 'on' : '')} onClick={() => tog('chatEnabled')}><span className="switch-knob"></span></button>
                    </div>
                </div>
            </div>
            <div className="settings-section">
                <h3 className="settings-section-title"><span className="section-icon">🔔</span> Уведомления</h3>
                <div className="settings-list">
                    <div className="settings-row">
                        <div><h4>Уведомления</h4><p>Об эфирах и ответах</p></div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {prefs.notifications && <button className="expand-arrow" onClick={() => setExp(!exp)}>{exp ? '▲' : '▼'}</button>}
                            <button className={'switch ' + (prefs.notifications ? 'on' : '')} onClick={() => tog('notifications')}><span className="switch-knob"></span></button>
                        </div>
                    </div>
                    {prefs.notifications && exp && (
                        <div className="settings-sub">
                            <div className="settings-row">
                                <div><h4>Звук</h4><p>Сигнал при уведомлении</p></div>
                                <button className={'switch ' + (prefs.notifSound ? 'on' : '')} onClick={() => tog('notifSound')}><span className="switch-knob"></span></button>
                            </div>
                            <div className="settings-row" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '12px' }}>
                                <h4>Выбор звука</h4>
                                <div className="sound-picker">
                                    {NOTIF_SOUND_OPTIONS.map((s) => (
                                        <button key={s.id} className={'sound-chip ' + (prefs.notifSoundType === s.id ? 'active' : '')} onClick={() => { setPrefs(p => Object.assign({}, p, { notifSoundType: s.id })); playNotifSound(vol, s.id); }}>{s.name}</button>
                                    ))}
                                </div>
                            </div>
                            <div className="settings-row">
                                <div className="volume-main">
                                    <h4>Громкость: <span className="vol-val">{vol}%</span></h4>
                                    <div className="volume-line">
                                        <input type="range" min="0" max="100" value={vol} onChange={(e) => volIn(Number(e.target.value))} onMouseUp={volCommit} onTouchEnd={volCommit} onKeyUp={volCommit} className="volume-slider" />
                                        <button className="btn-ghost sound-test-btn" onClick={() => playNotifSound(vol, prefs.notifSoundType)}>🔊 Тест</button>
                                    </div>
                                </div>
                            </div>
                            <div className="settings-row">
                                <div><h4>Уведомления браузера</h4><p>Всплывающие уведомления</p></div>
                                <button className="btn-ghost" onClick={reqPerm} style={{ padding: '8px 14px', fontSize: '13px' }}>{perm === 'granted' ? '✓ Разрешены' : perm === 'denied' ? '✕ Заблокированы' : 'Разрешить'}</button>
                            </div>
                            <div className="settings-row">
                                <div><h4>Проверить</h4><p>Тестовое уведомление</p></div>
                                <button className="btn-primary" onClick={testNotif} style={{ padding: '8px 14px', fontSize: '13px' }}>Отправить</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="settings-section">
                <h3 className="settings-section-title"><span className="section-icon">🔒</span> Безопасность</h3>
                <div className="settings-card">
                    {sec && <div className={sec.type === 'ok' ? 'msg-ok msg-block' : 'msg-error msg-block'}>{sec.text}</div>}
                    <form onSubmit={chPw} className="security-form">
                        <label className="auth-label">Сменить пароль</label>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            <input type="password" className="admin-input" style={{ flex: 1, minWidth: '220px', margin: 0 }} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Новый пароль" />
                            <button type="submit" className="btn-primary" disabled={busy}>Обновить</button>
                        </div>
                    </form>
                    <form onSubmit={chEm} className="security-form">
                        <label className="auth-label">Сменить почту</label>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            <input type="email" className="admin-input" style={{ flex: 1, minWidth: '220px', margin: 0 }} value={em} onChange={(e) => setEm(e.target.value)} placeholder="Новый email" />
                            <button type="submit" className="btn-primary" disabled={busy}>Обновить</button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="settings-section">
                <h3 className="settings-section-title"><span className="section-icon">⚙️</span> Аккаунт</h3>
                {session ? (
                    <div className="settings-row">
                        <div><h4>{profileExtras.displayName || 'LiveNet User'}</h4><p>{session.user.email}</p></div>
                        <button className="btn-ghost danger-ghost" onClick={handleLogout}>Выйти</button>
                    </div>
                ) : (
                    <div className="settings-row">
                        <div><h4>Вы не вошли</h4></div>
                        <button className="btn-primary" onClick={() => onOpenAuth('login')}>Войти</button>
                    </div>
                )}
            </div>
            {crop && <ImageCropper shape={crop === 'avatar' ? 'circle' : 'rect'} title={crop === 'avatar' ? 'Аватар' : 'Шапка'} allowAnimated={isAdmin && animEnabled} onSave={(d) => { setProfileExtras(p => Object.assign({}, p, { [crop]: d })); setCrop(null); }} onClose={() => setCrop(null)} />}
        </div>
    );
};

const ChannelMaintRow = ({ channel, onSaved, toast }) => {
    const [on, setOn] = useState(!!channel.maintenance);
    const [until, setUntil] = useState(channel.maintenanceUntil || '');
    const [link, setLink] = useState(channel.maintenanceLink || '');
    const save = async () => {
        await supabase.from('channels').update({ maintenance: on, maintenance_until: until || null, maintenance_link: link.trim() || null }).eq('id', channel.id);
        toast('Сохранено!');
        onSaved();
    };
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', padding: '14px', background: 'rgba(255,255,255,0.03)', borderRadius: '10px', border: '1px solid var(--border-color)', marginBottom: '8px' }}>
            <img src={channel.image || logo} alt=" " style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }} />
            <div style={{ flex: 1, minWidth: '140px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700' }}>{channel.name}</h4>
                <span style={{ fontSize: '12px', color: on ? '#ef4444' : 'var(--text-muted)' }}>{on ? '🛠 На тех. работах' : 'Работает'}</span>
            </div>
            <button onClick={() => setOn(!on)} style={{ width: '48px', height: '26px', borderRadius: '20px', border: 'none', cursor: 'pointer', background: on ? '#ef4444' : 'rgba(255,255,255,0.12)', position: 'relative', flexShrink: 0 }}>
                <span style={{ position: 'absolute', top: '2px', left: on ? '24px' : '2px', width: '22px', height: '22px', borderRadius: '50%', background: '#fff', transition: 'left 0.2s' }}></span>
            </button>
            <input type="datetime-local" className="admin-input" style={{ flex: 1, minWidth: '170px' }} value={until} onChange={(e) => setUntil(e.target.value)} />
            <input type="text" className="admin-input" style={{ flex: 1, minWidth: '170px' }} placeholder="Ссылка на новости" value={link} onChange={(e) => setLink(e.target.value)} />
            <button className="btn-primary" onClick={save} style={{ padding: '10px 16px' }}>💾</button>
        </div>
    );
};

const AdminPage = ({ adminCategories, setAdminCategories, adminChannels, setAdminChannels, setCurrentRoute, adminAuthenticated, setAdminAuthenticated, schedules, setSchedules, refreshData, toast, onlineTotal, onlineByChannel, maintenanceMode, setMaintenanceMode, maintenanceUntil, setMaintenanceUntil, openUserProfile, session }) => {
    const [passwordInput, setPasswordInput] = useState('');
    const [activeTab, setActiveTab] = useState('stats');
    const [newCat, setNewCat] = useState('');
    const [editCat, setEditCat] = useState(null);
    const [editCatName, setEditCatName] = useState('');
    const [chName, setChName] = useState('');
    const [chCategories, setChCategories] = useState([]);
    const [chDesc, setChDesc] = useState('');
    const [chStream, setChStream] = useState('');
    const [chImage, setChImage] = useState(null);
    const [chOff, setChOff] = useState(false);
    const [chAd, setChAd] = useState(false);
    const [chPart, setChPart] = useState(false);
    const [editCh, setEditCh] = useState(null);
    const [cropCh, setCropCh] = useState(false);
    const [catDropdownOpen, setCatDropdownOpen] = useState(false);
    const [sCh, setSCh] = useState(adminChannels[0] ? adminChannels[0].id : 1);
    const [sDay, setSDay] = useState('Понедельник');
    const [sText, setSText] = useState('');
    const [users, setUsers] = useState([]);
    const [userSearch, setUserSearch] = useState('');
    const [titleUsername, setTitleUsername] = useState('');
    const [titleType, setTitleType] = useState('');
    const [titleError, setTitleError] = useState('');
    const [openScheduleGroups, setOpenScheduleGroups] = useState({});
    const [annText, setAnnText] = useState('');
    const [annAuthor, setAnnAuthor] = useState('');
    const [animEnabled, setAnimEnabled] = useState(() => localStorage.getItem('ln_anim_enabled') !== 'false');
    const handleLogin = (e) => { e.preventDefault(); if (passwordInput === ADMIN_PASSWORD) setAdminAuthenticated(true); else alert('Неверный пароль!'); };
    const addCat = async () => { if (!newCat.trim()) return; await supabase.from('categories').insert({ name: newCat.trim() }); setNewCat(''); refreshData(); };
    const editCatSave = async (id) => { if (!editCatName.trim()) return; await supabase.from('categories').update({ name: editCatName.trim() }).eq('id', id); setEditCat(null); setEditCatName(''); refreshData(); };
    const delCat = async (id) => { if (!window.confirm('Удалить категорию?')) return; await supabase.from('categories').delete().eq('id', id); refreshData(); };
    const toggleChCategory = (cat) => { if (chCategories.includes(cat)) setChCategories(chCategories.filter(c => c !== cat)); else setChCategories([...chCategories, cat]); };
    const saveCh = async () => {
        if (!chName.trim()) return;
        const payload = { name: chName.trim(), category: chCategories.join(','), description: chDesc.trim(), stream_url: chStream.trim(), image_url: chImage, is_official: chOff, is_ad: chAd, is_partner: chPart };
        if (editCh) { await supabase.from('channels').update(payload).eq('id', editCh); setEditCh(null); toast('Канал обновлён!'); }
        else { await supabase.from('channels').insert(payload); toast('Канал создан!'); }
        setChName(''); setChDesc(''); setChStream(''); setChImage(null); setChCategories([]); setChOff(false); setChAd(false); setChPart(false);
        refreshData();
    };
    const startChEdit = (c) => { setEditCh(c.id); setChName(c.name); setChCategories(c.category ? c.category.split(',').map(x => x.trim()).filter(Boolean) : []); setChDesc(c.desc); setChStream(c.streamUrl || ''); setChImage(c.image); setChOff(c.isOfficial); setChAd(c.isAd); setChPart(c.isPartner); };
    const cancelChEdit = () => { setEditCh(null); setChName(''); setChDesc(''); setChStream(''); setChImage(null); setChCategories([]); };
    const delCh = async (id) => { if (!window.confirm('Удалить канал?')) return; await supabase.from('channels').delete().eq('id', id); refreshData(); };
    const parseSched = (t) => {
        const o = [];
        t.split(/\r?\n/).forEach(r => {
            const l = r.trim();
            if (!l) return;
            const m = l.match(/^(\d{1,2})[:.](\d{2})\s*[-–—|:]?\s*(.*)$/);
            if (m) o.push({ time: String(m[1]).padStart(2, '0') + ':' + m[2], title: (m[3] || 'Передача').trim() });
            else o.push({ time: '', title: l });
        });
        return o;
    };
    const addSched = async () => { const it = parseSched(sText); if (!it.length) return; await supabase.from('schedule_items').insert(it.map(i => ({ channel_id: sCh, day_name: sDay, time: i.time, title: i.title }))); setSText(''); refreshData(); };
    const delSched = async (id) => { await supabase.from('schedule_items').delete().eq('id', id); refreshData(); };
    const loadUsers = useCallback(async () => { const { data } = await supabase.from('profiles').select('*').order('display_name'); if (data) setUsers(data); }, []);
    const filteredUsers = useMemo(() => users.filter(u => { const search = userSearch.toLowerCase().replace(/^@/, '').trim(); if (!search) return true; return (u.display_name && u.display_name.toLowerCase().includes(search)) || (u.username && u.username.toLowerCase().includes(search)); }), [users, userSearch]);
    const assignTitle = async () => {
        setTitleError('');
        if (!titleUsername.trim() || !titleType) { setTitleError('Заполните все поля'); return; }
        const input = titleUsername.trim();
        if (!input.startsWith('@')) { setTitleError('Используйте только юзернейм (например @test)'); return; }
        const username = input.slice(1);
        const { data } = await supabase.from('profiles').select('id').eq('username', username).maybeSingle();
        if (!data) { setTitleError('Пользователь с юзернеймом @' + username + ' не найден'); return; }
        await supabase.from('profiles').update({ title: titleType }).eq('id', data.id);
        toast('Титул назначен!');
        setTitleUsername(''); setTitleType('');
        loadUsers();
    };
    const sendAnnouncement = async () => {
        if (!annText.trim()) { toast('Напишите текст объявления'); return; }
        await supabase.from('announcements').insert({ text: annText.trim(), author: annAuthor.trim() || 'Администрация LiveNet' });
        setAnnText(''); setAnnAuthor('');
        toast('Объявление отправлено всем!');
    };
    useEffect(() => { if (adminAuthenticated) loadUsers(); }, [adminAuthenticated, loadUsers]);
    useEffect(() => {
        if (!adminAuthenticated) return;
        const ch = supabase.channel('profiles_watch').on('postgres_changes', { event: '*', schema: 'public', table: 'profiles' }, () => { loadUsers(); }).subscribe();
        return () => { supabase.removeChannel(ch); };
    }, [adminAuthenticated, loadUsers]);
    const toggleScheduleGroup = (key) => { setOpenScheduleGroups(prev => ({ ...prev, [key]: !prev[key] })); };
    if (!adminAuthenticated) {
        return (
            <div className="admin-login-wrapper section-container">
                <div className="admin-login-box">
                    <h2>Панель управления LiveNet</h2>
                    <p>Введите пароль администратора</p>
                    <form onSubmit={handleLogin}>
                        <input type="password" placeholder="Пароль..." value={passwordInput} onChange={(e) => setPasswordInput(e.target.value)} className="admin-input-pw" autoFocus />
                        <button type="submit" className="btn-primary" style={{ width: '100%', padding: '14px' }}>Войти в админку</button>
                    </form>
                </div>
            </div>
        );
    }
    return (
        <div className="admin-panel-layout section-container">
            <aside className="admin-sidebar">
                <button className={'admin-tab-btn ' + (activeTab === 'stats' ? 'active' : '')} onClick={() => setActiveTab('stats')}>📊 Статистика</button>
                <button className={'admin-tab-btn ' + (activeTab === 'users' ? 'active' : '')} onClick={() => setActiveTab('users')}>👥 Пользователи</button>
                <button className={'admin-tab-btn ' + (activeTab === 'titles' ? 'active' : '')} onClick={() => setActiveTab('titles')}>🏆 Титулы</button>
                <button className={'admin-tab-btn ' + (activeTab === 'categories' ? 'active' : '')} onClick={() => setActiveTab('categories')}>🗂 Категории</button>
                <button className={'admin-tab-btn ' + (activeTab === 'channels' ? 'active' : '')} onClick={() => setActiveTab('channels')}>📺 Каналы</button>
                <button className={'admin-tab-btn ' + (activeTab === 'chmaint' ? 'active' : '')} onClick={() => setActiveTab('chmaint')}>🛠 ТО каналов</button>
                <button className={'admin-tab-btn ' + (activeTab === 'announce' ? 'active' : '')} onClick={() => setActiveTab('announce')}>📢 Объявление</button>
                <button className={'admin-tab-btn ' + (activeTab === 'schedule' ? 'active' : '')} onClick={() => setActiveTab('schedule')}>📅 Расписание</button>
                <button className={'admin-tab-btn ' + (activeTab === 'maintenance' ? 'active' : '')} onClick={() => setActiveTab('maintenance')}>⚙️ Тех. работы</button>
                <button className="admin-tab-btn" onClick={() => setCurrentRoute('main')} style={{ marginTop: 'auto', color: 'var(--accent-primary)' }}>➜ Главное меню</button>
                <button className="admin-tab-btn" onClick={() => setAdminAuthenticated(false)} style={{ color: '#ef4444' }}>🔒 Выйти с админки</button>
            </aside>
            <section className="admin-content-area">
                {activeTab === 'stats' && (
                    <div>
                        <h2>Статистика</h2>
                        <div className="admin-stats-grid">
                            <div className="admin-stat-card"><span>На сайте сейчас</span><strong>{onlineTotal}</strong></div>
                            <div className="admin-stat-card"><span>Всего каналов</span><strong>{adminChannels.length}</strong></div>
                            <div className="admin-stat-card"><span>Категорий</span><strong>{adminCategories.length}</strong></div>
                            <div className="admin-stat-card"><span>Пользователей</span><strong>{users.length}</strong></div>
                        </div>
                    </div>
                )}
                {activeTab === 'users' && (
                    <div>
                        <h2>Пользователи ({users.length})</h2>
                        <input type="text" placeholder="Поиск по нику или @юзернейму..." value={userSearch} onChange={(e) => setUserSearch(e.target.value)} className="admin-input" style={{ marginBottom: '20px' }} />
                        <div className="users-list" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {filteredUsers.map(u => {
                                const isMyAccount = session && session.user.id === u.id;
                                return (
                                    <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '14px', background: 'rgba(255,255,255,0.03)', borderRadius: '10px', border: '1px solid var(--border-color)' }}>
                                        <img src={u.avatar_url || DEFAULT_AVATAR} alt=" " onClick={() => openUserProfile(u.id, isMyAccount)} style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover', cursor: 'pointer' }} />
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontWeight: '700', cursor: 'pointer' }} onClick={() => openUserProfile(u.id, isMyAccount)}>{u.display_name}{u.title && <TitleBadge titleId={u.title} size="sm" />}</div>
                                            <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>@{u.username}{isMyAccount && <span style={{ color: 'var(--accent-primary)', marginLeft: '8px' }}>(это вы)</span>}</div>
                                        </div>
                                        <button className="btn-ghost mini-btn" onClick={() => openUserProfile(u.id, isMyAccount)}>Профиль</button>
                                    </div>
                                );
                            })}
                            {filteredUsers.length === 0 && <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '20px' }}>Пользователи не найдены</p>}
                        </div>
                    </div>
                )}
                {activeTab === 'titles' && (
                    <div>
                        <h2>Титулы</h2>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px', marginBottom: '30px' }}>
                            {TITLES.map(t => (
                                <div key={t.id} style={{ background: t.gradient, color: t.color, padding: '16px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '10px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}>
                                    <span style={{ fontSize: '24px' }}>{t.icon}</span>
                                    <div>
                                        <div style={{ fontWeight: '700', fontSize: '14px' }}>{t.name}</div>
                                        <div style={{ fontSize: '11px', opacity: 0.8 }}>{t.id}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <h3 style={{ marginBottom: '15px' }}>Назначить титул</h3>
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', flexWrap: 'wrap' }}>
                            <input type="text" placeholder="@юзернейм (например @dimaowner)" value={titleUsername} onChange={(e) => { setTitleUsername(e.target.value); setTitleError(''); }} className="admin-input" style={{ flex: '1', minWidth: '200px' }} />
                            <select value={titleType} onChange={(e) => setTitleType(e.target.value)} className="admin-input" style={{ flex: '1', minWidth: '200px' }}>
                                <option value="">Выберите титул</option>
                                {TITLES.map(t => <option key={t.id} value={t.id}>{t.icon} {t.name}</option>)}
                            </select>
                            <button className="btn-primary" onClick={assignTitle}>Назначить</button>
                        </div>
                        {titleError && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.35)', color: '#fca5a5', padding: '10px 14px', borderRadius: '10px', fontSize: '13px' }}>{titleError}</div>}
                    </div>
                )}
                {activeTab === 'categories' && (
                    <div>
                        <h2>Категории</h2>
                        <div className="admin-form-row">
                            <input type="text" placeholder="Название..." className="admin-input" value={newCat} onChange={(e) => setNewCat(e.target.value)} />
                            <button className="btn-primary" onClick={addCat}>Добавить</button>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {adminCategories.map((c) => (
                                <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px', background: 'rgba(255,255,255,0.03)', borderRadius: '10px', border: '1px solid var(--border-color)' }}>
                                    {editCat === c.id ? (
                                        <React.Fragment>
                                            <input type="text" className="admin-input" value={editCatName} onChange={(e) => setEditCatName(e.target.value)} style={{ flex: 1 }} />
                                            <button className="btn-primary" onClick={() => editCatSave(c.id)} style={{ padding: '8px 16px' }}>Сохранить</button>
                                            <button className="btn-ghost" onClick={() => setEditCat(null)} style={{ padding: '8px 16px' }}>Отмена</button>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <span style={{ flex: 1, fontWeight: '600' }}>{c.name}</span>
                                            <button className="btn-ghost" onClick={() => { setEditCat(c.id); setEditCatName(c.name); }} style={{ padding: '8px 14px' }}>✏️</button>
                                            <button className="btn-ghost danger-ghost" onClick={() => delCat(c.id)} style={{ padding: '8px 14px' }}>✕</button>
                                        </React.Fragment>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {activeTab === 'channels' && (
                    <div>
                        <h2>{editCh ? '✏️ Редактирование канала' : '➕ Новый канал'}</h2>
                        <div className="admin-editor-card" style={{ marginBottom: '24px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                                <input type="text" placeholder="Название" className="admin-input" value={chName} onChange={(e) => setChName(e.target.value)} />
                                <div style={{ position: 'relative' }}>
                                    <button type="button" onClick={() => setCatDropdownOpen(!catDropdownOpen)} className="admin-input" style={{ width: '100%', textAlign: 'left', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span>{chCategories.length > 0 ? chCategories.join(', ') : 'Выберите категории'}</span>
                                        <span style={{ color: 'var(--accent-primary)' }}>{catDropdownOpen ? '▲' : '▼'}</span>
                                    </button>
                                    {catDropdownOpen && (
                                        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: '4px', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: '10px', padding: '8px', zIndex: 20, maxHeight: '200px', overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
                                            {adminCategories.map((c) => (
                                                <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', cursor: 'pointer', borderRadius: '6px', transition: 'background 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(0,245,160,0.08)'} onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                                                    <input type="checkbox" checked={chCategories.includes(c.name)} onChange={() => toggleChCategory(c.name)} style={{ accentColor: 'var(--accent-primary)' }} />
                                                    <span>{c.name}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <textarea placeholder="Описание" className="admin-input" style={{ width: '100%', marginBottom: '15px', minHeight: '70px' }} value={chDesc} onChange={(e) => setChDesc(e.target.value)} />
                            <input type="text" placeholder="Ссылка m3u8 (https://.../stream.m3u8)" className="admin-input" style={{ width: '100%', marginBottom: '15px' }} value={chStream} onChange={(e) => setChStream(e.target.value)} />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '15px' }}>
                                <div style={{ width: '64px', height: '64px', borderRadius: '50%', border: '1px solid var(--border-color)', background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                    {chImage ? <img src={chImage} alt=" " style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ color: 'var(--text-muted)', fontSize: '12px' }}>Нет</span>}
                                </div>
                                <button className="btn-ghost" onClick={() => setCropCh(true)}>📁 Загрузить аватарку</button>
                                {chImage && <button className="btn-ghost danger-ghost" onClick={() => setChImage(null)}>✕ Удалить</button>}
                            </div>
                            <div className="chip-toggles" style={{ marginBottom: '15px' }}>
                                <label className={'chip-toggle ' + (chOff ? 'active' : '')}><input type="checkbox" checked={chOff} onChange={(e) => setChOff(e.target.checked)} /> 🏅 Официальный</label>
                                <label className={'chip-toggle ' + (chPart ? 'active' : '')}><input type="checkbox" checked={chPart} onChange={(e) => setChPart(e.target.checked)} /> 🤝 Партнёр</label>
                                <label className={'chip-toggle ' + (chAd ? 'active' : '')}><input type="checkbox" checked={chAd} onChange={(e) => setChAd(e.target.checked)} /> 📢 Реклама</label>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button className="btn-primary" onClick={saveCh}>{editCh ? '💾 Сохранить изменения' : '＋ Создать канал'}</button>
                                {editCh && <button className="btn-ghost" onClick={cancelChEdit}>Отмена</button>}
                            </div>
                        </div>
                        <h3 style={{ marginBottom: '16px' }}>Список каналов ({adminChannels.length})</h3>
                        {adminChannels.map(c => (
                            <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px', background: 'rgba(255,255,255,0.03)', borderRadius: '10px', border: '1px solid var(--border-color)', marginBottom: '8px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                    <img src={c.image || logo} alt=" " style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover' }} />
                                    <div>
                                        <h4 style={{ fontSize: '15px', fontWeight: '700' }}>{c.name}</h4>
                                        <span style={{ fontSize: '12px', color: c.live ? 'var(--accent-primary)' : 'var(--text-muted)', fontWeight: '600' }}>{c.category} · {c.live ? '🔴 В эфире' : 'Оффлайн'} · 👁 {onlineByChannel[c.id] || 0}</span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <button className="btn-ghost" onClick={() => startChEdit(c)} style={{ padding: '8px 14px', fontSize: '12px' }}>✏️</button>
                                    <button className="btn-ghost danger-ghost" onClick={() => delCh(c.id)} style={{ padding: '8px 14px', fontSize: '12px' }}>✕</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {activeTab === 'chmaint' && (
                    <div>
                        <h2>🛠 Тех. работы каналов</h2>
                        <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '16px' }}>Включи тумблер — пользователи, которые сейчас смотрят этот канал, сразу увидят заставку технических работ без перезагрузки страницы.</p>
                        {adminChannels.map(c => <ChannelMaintRow key={c.id} channel={c} onSaved={refreshData} toast={toast} />)}
                    </div>
                )}
                {activeTab === 'announce' && (
                    <div>
                        <h2>📢 Объявление всем</h2>
                        <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '16px' }}>Сообщение придёт всем пользователям сайта мгновенно, со звуком, без перезагрузки страницы. Если ник не указать — подпишется как «Администрация LiveNet».</p>
                        <textarea placeholder="Текст объявления..." className="admin-input" style={{ width: '100%', marginBottom: '12px', minHeight: '90px' }} value={annText} onChange={(e) => setAnnText(e.target.value)} />
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <input type="text" placeholder="Ник (необязательно)" className="admin-input" value={annAuthor} onChange={(e) => setAnnAuthor(e.target.value)} />
                            <button className="btn-primary" onClick={sendAnnouncement}>Отправить всем</button>
                        </div>
                    </div>
                )}
                {activeTab === 'schedule' && (
                    <div>
                        <h2>Расписание</h2>
                        <div className="admin-editor-card" style={{ marginBottom: '24px' }}>
                            <h3 style={{ marginBottom: '16px' }}>➕ Добавить передачи</h3>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                                <select className="admin-input" value={sCh} onChange={(e) => setSCh(Number(e.target.value))}>{adminChannels.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select>
                                <select className="admin-input" value={sDay} onChange={(e) => setSDay(e.target.value)}>{['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'].map((d) => <option key={d} value={d}>{d}</option>)}</select>
                            </div>
                            <textarea placeholder={'19:00 — Вечерний эфир\n22:00 Ночной кинопоказ\nПросто текст без времени'} className="admin-input" style={{ width: '100%', marginBottom: '15px', minHeight: '90px' }} value={sText} onChange={(e) => setSText(e.target.value)} />
                            <button className="btn-primary" onClick={addSched}>➕ Добавить</button>
                        </div>
                        <h3 style={{ marginBottom: '16px' }}>Сетка вещания</h3>
                        {Object.keys(schedules).length === 0 && <p style={{ color: 'var(--text-muted)' }}>Пусто.</p>}
                        {Object.entries(schedules).map(([cid, days]) => {
                            const ch = adminChannels.find(c => String(c.id) === String(cid));
                            const isOpen = openScheduleGroups[cid];
                            return (
                                <div key={cid} style={{ marginBottom: '8px' }}>
                                    <button onClick={() => toggleScheduleGroup(cid)} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '14px', padding: '14px 16px', background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border-color)', borderRadius: '10px', cursor: 'pointer', color: 'var(--text-main)', textAlign: 'left' }}>
                                        <img src={(ch && ch.image) || logo} alt=" " style={{ width: '38px', height: '38px', borderRadius: '50%', objectFit: 'cover' }} />
                                        <div style={{ flex: 1 }}>
                                            <h4 style={{ fontSize: '15px', fontWeight: '700', margin: 0 }}>{ch ? ch.name : 'Канал'}</h4>
                                            <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{Object.values(days).flat().length} передач</span>
                                        </div>
                                        <span style={{ fontSize: '12px', color: 'var(--accent-primary)', transition: 'transform 0.25s', transform: isOpen ? 'rotate(180deg)' : 'rotate(0)' }}>▼</span>
                                    </button>
                                    {isOpen && (
                                        <div style={{ marginTop: '8px', padding: '12px 14px', background: 'rgba(255,255,255,0.02)', border: '1px solid var(--border-color)', borderRadius: '10px' }}>
                                            {Object.entries(days).map(([day, items]) => (
                                                <div key={day} style={{ marginBottom: '12px' }}>
                                                    <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--accent-primary)', marginBottom: '6px' }}>{day}</div>
                                                    {items.map((it) => (
                                                        <div key={it.id} style={{ display: 'flex', gap: '12px', fontSize: '13px', marginBottom: '4px', alignItems: 'center' }}>
                                                            <span style={{ color: 'var(--accent-primary)', fontWeight: '600', minWidth: '52px' }}>{it.time || '—'}</span>
                                                            <span style={{ flex: 1 }}>{it.title}</span>
                                                            <button className="btn-ghost danger-ghost" onClick={() => delSched(it.id)} style={{ padding: '4px 10px', fontSize: '11px' }}>✕</button>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
                {activeTab === 'maintenance' && (
                    <div>
                        <h2>Технические работы (весь сайт)</h2>
                        <div style={{ background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border-color)', borderRadius: '12px', padding: '24px', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '20px', flexWrap: 'wrap' }}>
                                <div>
                                    <h3 style={{ fontSize: '16px', marginBottom: '4px' }}>Режим технических работ</h3>
                                    <p style={{ color: 'var(--text-muted)', fontSize: '13px' }}>Сайт будет недоступен для всех пользователей</p>
                                </div>
                                <button onClick={() => setMaintenanceMode(!maintenanceMode)} style={{ width: '52px', height: '28px', borderRadius: '20px', border: 'none', cursor: 'pointer', background: maintenanceMode ? 'var(--accent-primary)' : 'rgba(255,255,255,0.12)', position: 'relative', transition: 'all 0.3s ease', flexShrink: 0 }}>
                                    <span style={{ position: 'absolute', top: '2px', left: maintenanceMode ? '26px' : '2px', width: '24px', height: '24px', borderRadius: '50%', background: maintenanceMode ? '#000' : '#fff', transition: 'left 0.3s ease' }}></span>
                                </button>
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '8px' }}>Таймер завершения (опционально)</label>
                                <input type="datetime-local" className="admin-input" value={maintenanceUntil} onChange={(e) => setMaintenanceUntil(e.target.value)} />
                            </div>
                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                {maintenanceUntil && (
                                    <button className="btn-ghost" onClick={() => setMaintenanceUntil('')} style={{ padding: '8px 16px', fontSize: '13px' }}>Убрать таймер</button>
                                )}
                                <button className="btn-ghost" onClick={() => { const d = new Date(Date.now() + 3600000); setMaintenanceUntil(d.toISOString().slice(0, 16)); }} style={{ padding: '8px 16px', fontSize: '13px' }}>+1 час</button>
                                <button className="btn-ghost" onClick={() => { const d = new Date(Date.now() + 86400000); setMaintenanceUntil(d.toISOString().slice(0, 16)); }} style={{ padding: '8px 16px', fontSize: '13px' }}>+1 сутки</button>
                            </div>
                        </div>
                        <div style={{ background: maintenanceMode ? 'rgba(239,68,68,0.08)' : 'rgba(0,245,160,0.08)', border: '1px solid ' + (maintenanceMode ? 'rgba(239,68,68,0.3)' : 'rgba(0,245,160,0.3)'), borderRadius: '12px', padding: '16px' }}>
                            <strong style={{ color: maintenanceMode ? '#ef4444' : 'var(--accent-primary)' }}>{maintenanceMode ? '⚠️ Технические работы ВКЛЮЧЕНЫ — пользователи видят страницу работ' : '✓ Сайт работает нормально'}</strong>
                        </div>
                    </div>
                )}
            </section>
            {cropCh && <ImageCropper shape="circle" title="Аватар канала" allowAnimated={animEnabled} onSave={(d) => { setChImage(d); setCropCh(false); }} onClose={() => setCropCh(false)} />}
        </div>
    );
};

const MaintenancePage = ({ maintenanceUntil }) => {
    const [timeLeft, setTimeLeft] = useState('');
    useEffect(() => {
        if (!maintenanceUntil) { setTimeLeft(''); return; }
        const tick = () => {
            const diff = new Date(maintenanceUntil).getTime() - Date.now();
            if (diff <= 0) { setTimeLeft('Скоро...'); return; }
            const days = Math.floor(diff / 86400000);
            const hours = Math.floor((diff % 86400000) / 3600000);
            const mins = Math.floor((diff % 3600000) / 60000);
            const secs = Math.floor((diff % 60000) / 1000);
            if (days > 0) setTimeLeft(`${days}д ${hours}ч ${mins}м ${secs}с`);
            else if (hours > 0) setTimeLeft(`${hours}ч ${mins}м ${secs}с`);
            else setTimeLeft(`${mins}м ${secs}с`);
        };
        tick();
        const iv = setInterval(tick, 1000);
        return () => clearInterval(iv);
    }, [maintenanceUntil]);
    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'linear-gradient(135deg, #0a0d14 0%, #101218 50%, #1a1d26 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px', textAlign: 'center', overflow: 'hidden' }}>
            <div style={{ position: 'relative', marginBottom: '32px' }}>
                <div style={{ width: '120px', height: '120px', borderRadius: '50%', border: '4px solid rgba(0,245,160,0.1)', borderTopColor: '#00f5a0', animation: 'spin 1.5s linear infinite', boxShadow: '0 0 40px rgba(0,245,160,0.3)' }}></div>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '40px' }}>⚙️</div>
            </div>
            <h1 style={{ fontFamily: "'Unbounded', sans-serif", fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: '900', marginBottom: '16px', background: 'linear-gradient(135deg, #00f5a0, #00d9f5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Технические работы</h1>
            <p style={{ color: '#a0aec0', fontSize: '1.1rem', maxWidth: '500px', marginBottom: '32px' }}>Сайт временно недоступен. Мы проводим работы для улучшения сервиса.</p>
            {timeLeft && (
                <div style={{ background: 'rgba(0,245,160,0.08)', border: '1px solid rgba(0,245,160,0.3)', borderRadius: '16px', padding: '20px 32px', marginBottom: '32px' }}>
                    <div style={{ fontSize: '12px', color: '#00f5a0', fontWeight: '700', marginBottom: '8px' }}>До завершения работ</div>
                    <div style={{ fontFamily: "'Unbounded', sans-serif", fontSize: 'clamp(2rem, 6vw, 3.5rem)', fontWeight: '900', color: '#fff' }}>{timeLeft}</div>
                </div>
            )}
            <a href="https://t.me/livenet_official" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'linear-gradient(135deg, #0088cc, #00a0e9)', color: '#fff', padding: '14px 28px', borderRadius: '12px', textDecoration: 'none', fontWeight: '700' }}>Следите за новостями в Telegram</a>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
};

export default function App() {
    const [session, setSession] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [currentRoute, setCurrentRoute] = useState(() => sessionStorage.getItem('livenet_current_route') || 'main');
    const [selected, setSelected] = useState(null);
    const [authMode, setAuthMode] = useState(null);
    const [adminAuthenticated, setAdminAuthenticated] = useState(false);
    const [previousRoute, setPreviousRoute] = useState(null);
    const [channels, setChannels] = useState([]);
    const [categories, setCategories] = useState([]);
    const [schedules, setSchedules] = useState({});
    const [loading, setLoading] = useState(true);
    const [subscriptions, setSubscriptions] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [viewingUserId, setViewingUserId] = useState(null);
    const [highlight, setHighlight] = useState(null);
    const [toastMsg, setToastMsg] = useState(null);
    const [profileExtras, setProfileExtras] = useState({ displayName: '', username: '', bio: '', bioPrivate: false, avatar: null, banner: null });
    const [prefs, setPrefs] = useState(() => {
        const d = { autoplay: true, notifications: true, notifSound: true, notifSoundType: 'chime', notifVolume: 70, chatEnabled: true };
        try { return Object.assign({}, d, JSON.parse(localStorage.getItem('livenet_prefs') || '{}')); } catch (e) { return d; }
    });
    const [notifOpen, setNotifOpen] = useState(false);
    const [profileOpen, setProfileOpen] = useState(false);
    const [maintenanceMode, setMaintenanceMode] = useState(() => localStorage.getItem('ln_maintenance') === 'true');
    const [maintenanceUntil, setMaintenanceUntil] = useState(() => localStorage.getItem('ln_maintenance_until') || '');
    const [splash, setSplash] = useState(() => !sessionStorage.getItem('livenet_splash'));
    const notifRef = useRef(null);
    const profileRef = useRef(null);
    const prefsRef = useRef(prefs);
    const seenAnnRef = useRef(new Set(JSON.parse(localStorage.getItem('ln_seen_ann') || '[]')));
    useEffect(() => { prefsRef.current = prefs; }, [prefs]);
    useEffect(() => { sessionStorage.setItem('livenet_current_route', currentRoute); }, [currentRoute]);
    useEffect(() => { localStorage.setItem('livenet_prefs', JSON.stringify(prefs)); }, [prefs]);
    useEffect(() => { if (currentRoute !== 'player') setHighlight(null); }, [currentRoute]);
    useEffect(() => { localStorage.setItem('ln_maintenance', maintenanceMode ? 'true' : 'false'); }, [maintenanceMode]);
    useEffect(() => { localStorage.setItem('ln_maintenance_until', maintenanceUntil); }, [maintenanceUntil]);
    useEffect(() => { if (splash) { const t = setTimeout(() => { setSplash(false); sessionStorage.setItem('livenet_splash', '1'); }, 2400); return () => clearTimeout(t); } }, [splash]);
    const toast = useCallback((m) => { setToastMsg(m); setTimeout(() => setToastMsg(null), 2600); }, []);
    const isAdminUser = (session && session.user.email === ADMIN_EMAIL) || (userProfile && userProfile.is_admin === true);
    const displayName = profileExtras.displayName || (userProfile ? userProfile.display_name : '') || 'LiveNet User';
    const activeChannelId = (currentRoute === 'player' && selected) ? selected.id : null;
    const online = useOnlineHeartbeat(activeChannelId);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const channelName = params.get('channel');
        if (channelName && channels.length > 0) {
            const ch = channels.find(c => c.name === channelName);
            if (ch) { setSelected(ch); setCurrentRoute('player'); window.history.replaceState({}, '', window.location.pathname); }
        }
    }, [channels]);

    useEffect(() => {
        const ch = supabase.channel('channels_watch').on('postgres_changes', { event: '*', schema: 'public', table: 'channels' }, (pl) => {
            if (pl.eventType === 'UPDATE') {
                const fresh = mapChannel(pl.new);
                setChannels(prev => prev.map(c => c.id === fresh.id ? fresh : c));
                setSelected(prev => (prev && prev.id === fresh.id) ? fresh : prev);
            } else {
                refresh();
            }
        }).subscribe();
        return () => { supabase.removeChannel(ch); };
    }, []);

    useEffect(() => {
        if (!selected) return;
        const iv = setInterval(async () => {
            const { data } = await supabase.from('channels').select('*').eq('id', selected.id).maybeSingle();
            if (data) {
                const fresh = mapChannel(data);
                setSelected(prev => (prev && prev.id === fresh.id) ? fresh : prev);
                setChannels(prev => prev.map(c => c.id === fresh.id ? fresh : c));
            }
        }, 8000);
        return () => clearInterval(iv);
    }, [selected]);

    useEffect(() => {
        const ch = supabase.channel('global_profiles_title_watch').on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'profiles' }, (pl) => {
            setUserProfile(prev => (prev && prev.id === pl.new.id) ? Object.assign({}, prev, { title: pl.new.title }) : prev);
        }).subscribe();
        return () => { supabase.removeChannel(ch); };
    }, []);

    useEffect(() => {
        supabase.from('announcements').select('*').order('created_at', { ascending: false }).limit(20).then(({ data }) => {
            if (!data) return;
            const cutoff = Date.now() - 7 * 24 * 3600 * 1000;
            const items = [];
            data.forEach(a => {
                if (new Date(a.created_at).getTime() < cutoff) return;
                if (seenAnnRef.current.has(a.id)) return;
                seenAnnRef.current.add(a.id);
                items.push({
                    id: 'ann_' + a.id,
                    text: '📢 ' + (a.author || 'Администрация LiveNet') + ': ' + a.text,
                    type: 'announce',
                    is_read: false,
                    time: new Date(a.created_at).toLocaleString([], { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
                });
            });
            if (items.length) {
                localStorage.setItem('ln_seen_ann', JSON.stringify([...seenAnnRef.current]));
                setNotifications(prev => [...items, ...prev]);
            }
        });
        const ch = supabase.channel('ann_watch').on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'announcements' }, (pl) => {
            const a = pl.new;
            if (seenAnnRef.current.has(a.id)) return;
            seenAnnRef.current.add(a.id);
            localStorage.setItem('ln_seen_ann', JSON.stringify([...seenAnnRef.current]));
            const item = {
                id: 'ann_' + a.id,
                text: '📢 ' + (a.author || 'Администрация LiveNet') + ': ' + a.text,
                type: 'announce',
                is_read: false,
                time: 'только что'
            };
            setNotifications(prev => [item, ...prev]);
            const p = prefsRef.current;
            if (p.notifSound !== false) playNotifSound(p.notifVolume || 70, p.notifSoundType || 'chime');
            showBrowserNotif('LiveNet', a.text, p);
            toast('Новое объявление от администрации 📢');
        }).subscribe();
        return () => { supabase.removeChannel(ch); };
    }, []);

    useEffect(() => {
        const maintCh = supabase.channel('site_maintenance').on('broadcast', { event: 'maintenance_update' }, ({ payload }) => {
            setMaintenanceMode(!!payload.enabled);
            setMaintenanceUntil(payload.until || '');
            localStorage.setItem('ln_maintenance', payload.enabled ? 'true' : 'false');
            localStorage.setItem('ln_maintenance_until', payload.until || '');
        }).subscribe();
        let userCh = null;
        if (session && session.user) {
            userCh = supabase.channel('user_notif_' + session.user.id).on('broadcast', { event: 'new_notif' }, ({ payload }) => {
                const newItem = { id: 'rt_' + Date.now(), text: payload.text, type: payload.type, channelId: payload.channelId, is_read: false, time: 'только что' };
                setNotifications(prev => [newItem, ...prev]);
                showBrowserNotif('LiveNet', payload.text, prefsRef.current);
            }).subscribe();
        }
        return () => { supabase.removeChannel(maintCh); if (userCh) supabase.removeChannel(userCh); };
    }, [session]);

    useEffect(() => {
        supabase.channel('site_maintenance').send({ type: 'broadcast', event: 'maintenance_update', payload: { enabled: maintenanceMode, until: maintenanceUntil } });
    }, [maintenanceMode, maintenanceUntil]);

    const refresh = useCallback(async () => {
        setLoading(true);
        try {
            const [ch, ca, sc] = await Promise.all([
                supabase.from('channels').select('*').order('id'),
                supabase.from('categories').select('*').order('id'),
                supabase.from('schedule_items').select('*')
            ]);
            if (ch.data) setChannels(ch.data.map(mapChannel));
            if (ca.data) setCategories(ca.data.map(r => ({ id: r.id, name: r.name })));
            if (sc.data) setSchedules(buildSchedules(sc.data));
        } catch (e) { toast('Не удалось загрузить данные'); }
        setLoading(false);
    }, [toast]);

    useEffect(() => { refresh(); }, [refresh]);

    useEffect(() => {
        let al = null;
        supabase.auth.getSession().then(({ data }) => { setSession(data.session); });
        const { data } = supabase.auth.onAuthStateChange((e, s) => { setSession(s); });
        al = data;
        const handleClickOutside = (e) => {
            if (notifRef.current && !notifRef.current.contains(e.target)) setNotifOpen(false);
            if (profileRef.current && !profileRef.current.contains(e.target)) setProfileOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            if (al && al.subscription) al.subscription.unsubscribe();
        };
    }, []);

    useEffect(() => {
        if (session) {
            supabase.from('profiles').select('*').eq('id', session.user.id).single().then(({ data }) => {
                if (data) {
                    setUserProfile(data);
                    setProfileExtras({ displayName: data.display_name || '', username: data.username || '', bio: data.bio || '', bioPrivate: !!data.bio_private, avatar: data.avatar_url || null, banner: data.banner_url || null });
                }
            });
        } else {
            setUserProfile(null);
            setProfileExtras({ displayName: '', username: '', bio: '', bioPrivate: false, avatar: null, banner: null });
        }
    }, [session]);

    useEffect(() => {
        if (!session) { setSubscriptions([]); setNotifications([]); return; }
        supabase.from('subscriptions').select('channel_id').eq('user_id', session.user.id).then(r => {
            if (r.data) setSubscriptions(r.data.map(x => x.channel_id));
        });
        supabase.from('notifications').select('*').eq('user_id', session.user.id).order('created_at', { ascending: false }).limit(50).then(r => {
            if (r.data) {
                setNotifications(r.data.map(n => ({
                    id: n.id, text: n.text, type: n.type, channelId: n.channel_id, is_read: n.is_read,
                    time: n.created_at ? new Date(n.created_at).toLocaleString([], { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''
                })));
            }
        });
    }, [session]);

    useEffect(() => {
        if (!session) return;
        const ch = supabase.channel('my_notifs_' + session.user.id).on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'notifications', filter: 'user_id=eq.' + session.user.id }, (pl) => {
            const newItem = { id: pl.new.id, text: pl.new.text, type: pl.new.type, channelId: pl.new.channel_id, is_read: false, time: 'только что' };
            setNotifications(prev => prev.some(n => n.id === pl.new.id) ? prev : [newItem, ...prev]);
            showBrowserNotif('LiveNet', pl.new.text, prefsRef.current);
        }).subscribe();
        return () => supabase.removeChannel(ch);
    }, [session]);

    const toggleSubscription = async (id) => {
        if (id == null) return;
        if (!session) { setAuthMode('login'); return; }
        const isSub = subscriptions.includes(id);
        if (isSub) {
            setSubscriptions(p => p.filter(x => x !== id));
            await supabase.from('subscriptions').delete().eq('user_id', session.user.id).eq('channel_id', id);
        } else {
            setSubscriptions(p => [...p, id]);
            await supabase.from('subscriptions').insert({ user_id: session.user.id, channel_id: id });
        }
    };

    const onProfileUpdated = (u) => setUserProfile(p => Object.assign({}, p, u));
    const openProfile = (userId, isSelf) => { setPreviousRoute(currentRoute); setViewingUserId(isSelf ? null : userId); setCurrentRoute('profile'); };

    const markAllRead = () => {
        setNotifications(p => p.map(n => Object.assign({}, n, { is_read: true })));
        if (session) supabase.from('notifications').update({ is_read: true }).eq('user_id', session.user.id).then(() => {});
    };
    const clearAllNotifs = () => {
        setNotifications([]);
        if (session) supabase.from('notifications').delete().eq('user_id', session.user.id).then(() => {});
    };
    const onNotif = (n) => {
        if (n.type === 'announce') {
            setNotifications(p => p.map(x => x.id === n.id ? Object.assign({}, x, { is_read: true }) : x));
            setNotifOpen(false);
            return;
        }
        setNotifications(p => p.map(x => x.id === n.id ? Object.assign({}, x, { is_read: true }) : x));
        if (session && typeof n.id === 'string' && n.id.startsWith('rt_')) return;
        if (session) supabase.from('notifications').update({ is_read: true }).eq('id', n.id).then(() => {});
        if (n.type === 'stream') {
            const c = channels.find(x => x.id === n.channelId) || channels[0];
            if (c) { setSelected(c); setCurrentRoute('player'); }
        } else if (n.type === 'reply') {
            const c = channels.find(x => x.id === n.channelId) || channels[0];
            if (c) { setSelected(c); setCurrentRoute('player'); }
            if (n.user) setHighlight(n.user);
        }
        setNotifOpen(false);
    };

    const unread = notifications.filter(n => !n.is_read).length;
    const eff = (currentRoute === 'player' && !selected) ? 'channels' : (currentRoute === 'admin' && !isAdminUser) ? 'main' : currentRoute;
    const showMaintenance = maintenanceMode && !isAdminUser;

    return (
        <div className="app-root">
            {splash && !showMaintenance && <Splash />}
            {showMaintenance ? (
                <MaintenancePage maintenanceUntil={maintenanceUntil} />
            ) : (
                <React.Fragment>
                    <Header
                        session={session} userProfile={userProfile} profileExtras={profileExtras} displayName={displayName}
                        isAdmin={isAdminUser} currentRoute={currentRoute} setCurrentRoute={setCurrentRoute}
                        notifOpen={notifOpen} setNotifOpen={setNotifOpen} profileOpen={profileOpen} setProfileOpen={setProfileOpen}
                        notifRef={notifRef} profileRef={profileRef} notifications={notifications} unreadCount={unread}
                        markAllRead={markAllRead} clearAllNotifs={clearAllNotifs} onOpenAuth={setAuthMode}
                        onNotifClick={onNotif} onOpenProfile={() => openProfile(null, true)}
                    />
                    <main className="app-main-content">
                        {eff === 'main' && <MainPage setCurrentRoute={setCurrentRoute} />}
                        {eff === 'channels' && <ChannelsPage adminCategories={categories} adminChannels={channels} setSelectedChannel={setSelected} setCurrentRoute={setCurrentRoute} loading={loading} onlineByChannel={online.byChannel} />}
                        {eff === 'about' && <AboutPage />}
                        {eff === 'admin' && isAdminUser && (
                            <AdminPage
                                adminCategories={categories} setAdminCategories={setCategories}
                                adminChannels={channels} setAdminChannels={setChannels}
                                setCurrentRoute={setCurrentRoute} adminAuthenticated={adminAuthenticated}
                                setAdminAuthenticated={setAdminAuthenticated} schedules={schedules} setSchedules={setSchedules}
                                refreshData={refresh} toast={toast} onlineTotal={online.total} onlineByChannel={online.byChannel}
                                maintenanceMode={maintenanceMode} setMaintenanceMode={setMaintenanceMode}
                                maintenanceUntil={maintenanceUntil} setMaintenanceUntil={setMaintenanceUntil}
                                openUserProfile={openProfile} session={session}
                            />
                        )}
                        {eff === 'player' && (
                            <PlayerPage
                                selectedChannel={selected} setCurrentRoute={setCurrentRoute} schedules={schedules}
                                isAdmin={isAdminUser} session={session} displayName={displayName}
                                onRequireAuth={() => setAuthMode('login')} subscriptions={subscriptions}
                                toggleSubscription={toggleSubscription} prefs={prefs} highlightUser={highlight}
                                openUserProfile={openProfile} onlineByChannel={online.byChannel} toast={toast}
                            />
                        )}
                        {eff === 'profile' && (
                            <ProfilePage
                                session={session} userProfile={userProfile} profileExtras={profileExtras}
                                subscriptions={subscriptions} viewingUserId={viewingUserId}
                                setCurrentRoute={setCurrentRoute} onOpenAuth={() => setAuthMode('login')}
                                previousRoute={previousRoute}
                            />
                        )}
                        {eff === 'subscriptions' && (
                            <SubscriptionsPage
                                adminChannels={channels} subscriptions={subscriptions} toggleSubscription={toggleSubscription}
                                setSelectedChannel={setSelected} setCurrentRoute={setCurrentRoute}
                                session={session} openUserProfile={openProfile}
                            />
                        )}
                        {eff === 'settings' && (
                            <SettingsPage
                                session={session} userProfile={userProfile} prefs={prefs} setPrefs={setPrefs}
                                profileExtras={profileExtras} setProfileExtras={setProfileExtras}
                                onOpenAuth={() => setAuthMode('login')} notify={(t) => toast(t)}
                                onProfileUpdated={onProfileUpdated} setCurrentRoute={setCurrentRoute} isAdmin={isAdminUser}
                            />
                        )}
                    </main>
                </React.Fragment>
            )}
            {authMode && <AuthModal authMode={authMode} onClose={() => setAuthMode(null)} onSwitchMode={setAuthMode} />}
            {toastMsg && <div className="app-toast">{toastMsg}</div>}
        </div>
    );
}